import { createSitemap } from '@mui/internal-docs-infra/createSitemap';
const Overview = null;
const Handbook = null;
const Components = null;
const Utils = null;

export const sitemap = createSitemap(import.meta.url, { Overview, Handbook, Components, Utils }, { precompute: {
  "schema": {
    "slug": "string",
    "path": "string",
    "title": "string",
    "description": "string",
    "sections": "string[]",
    "subsections": "string[]",
    "keywords": "string[]"
  },
  "data": {
    "Overview": {
      "title": "React Overview",
      "pages": [
        {
          "slug": "quick-start",
          "path": "./quick-start/page.mdx",
          "title": "Quick start",
          "description": "A quick guide to getting started with Base UI.",
          "keywords": [
            "Base UI Quick Start",
            "Install Base UI",
            "Base UI shadcn",
            "Base UI shadcn/ui",
            "React Portal Setup",
            "iOS Safari Backdrop Fix",
            "Popover Assembly Example",
            "llms.txt Link",
            "Getting Started Guide",
            "npm Install",
            "Setup Guide",
            "Installation Guide",
            "Getting Started Tutorial",
            "First Steps",
            "Beginner Guide"
          ],
          "sections": {
            "install-the-library": {
              "title": "Install the library"
            },
            "set-up": {
              "title": "Set up",
              "children": {
                "portals": {
                  "title": "Portals"
                },
                "ios-26-safari": {
                  "title": "iOS 26+ Safari"
                }
              }
            },
            "assemble-a-component": {
              "title": "Assemble a component"
            },
            "pre-styled-components": {
              "title": "Pre-styled components"
            },
            "working-with-llms": {
              "title": "Working with LLMs"
            },
            "next-steps": {
              "title": "Next steps"
            }
          }
        },
        {
          "slug": "accessibility",
          "path": "./accessibility/page.mdx",
          "title": "Accessibility",
          "description": "Learn how to make the most of Base UI's accessibility features and guidelines.",
          "keywords": [
            "Base UI Accessibility",
            "React Accessibility Guidelines",
            "Keyboard Navigation Base UI",
            "Focus Management Tips",
            "Color Contrast Guidance",
            "Accessible Labels Base UI",
            "Accessibility Overview",
            "WCAG Compliance",
            "ARIA Attributes",
            "A11y",
            "Screen Reader Support",
            "Accessible UI",
            "Inclusive Design"
          ],
          "sections": {
            "keyboard-navigation": {
              "title": "Keyboard navigation"
            },
            "focus-management": {
              "title": "Focus management"
            },
            "color-contrast": {
              "title": "Color contrast"
            },
            "accessible-labels": {
              "title": "Accessible labels"
            },
            "testing": {
              "title": "Testing"
            }
          }
        },
        {
          "slug": "releases",
          "path": "./releases/page.mdx",
          "title": "Releases",
          "description": "Changelogs for each Base UI release.",
          "keywords": [
            "Base UI releases",
            "Base UI changelog",
            "Release notes beta",
            "Breaking changes Base UI",
            "Component updates history",
            "Headless React release log",
            "Version history",
            "Changelog history",
            "Upgrade guide",
            "Migration guide",
            "What's new",
            "Release updates"
          ],
          "sections": {
            "canary-releases": {
              "title": "Canary releases"
            },
            "full-release-notes": {
              "title": "Full release notes"
            }
          }
        },
        {
          "slug": "community",
          "path": "./community/page.mdx",
          "title": "Community",
          "description": "The Base UI ecosystem, support channels, and ways to stay up to date.",
          "tags": [
            "New"
          ],
          "keywords": [
            "Base UI Community",
            "Base UI shadcn",
            "Base UI shadcn/ui",
            "Base UI GitHub",
            "Base UI Discord",
            "Base UI X",
            "Base UI Bluesky",
            "Base UI Styling",
            "Base UI Ecosystem",
            "Base UI Support",
            "Headless React Community",
            "Accessible React Components"
          ],
          "sections": {
            "shadcn-ui-integration": {
              "title": "shadcn/ui integration"
            },
            "styled-libraries": {
              "title": "Styled libraries"
            },
            "unofficial-ports": {
              "title": "Unofficial ports"
            },
            "get-help-and-contribute": {
              "title": "Get help and contribute",
              "children": {
                "github": {
                  "title": "GitHub"
                },
                "discord": {
                  "title": "Discord"
                }
              }
            },
            "stay-up-to-date": {
              "title": "Stay up to date",
              "children": {
                "x": {
                  "title": "X"
                },
                "bluesky": {
                  "title": "Bluesky"
                },
                "github-releases": {
                  "title": "GitHub releases"
                }
              }
            }
          }
        },
        {
          "slug": "about-base-ui",
          "path": "./about/page.mdx",
          "title": "About Base UI",
          "description": "An open-source React component library for building accessible user interfaces.",
          "keywords": [
            "About Base UI",
            "Base UI Team",
            "Headless React Components",
            "Accessible React Library",
            "Open Source UI Components",
            "Base UI Community",
            "Base UI Overview",
            "Unstyled Components",
            "Component Library",
            "Headless UI Library",
            "React UI Toolkit",
            "MUI Team",
            "Radix Alternative"
          ],
          "sections": {
            "features": {
              "title": "Features",
              "children": {
                "headless": {
                  "title": "Headless"
                },
                "accessible": {
                  "title": "Accessible"
                },
                "composable": {
                  "title": "Composable"
                }
              }
            },
            "team": {
              "title": "Team"
            },
            "browser-support": {
              "title": "Browser support"
            },
            "react-versions": {
              "title": "React versions"
            },
            "community": {
              "title": "Community"
            }
          }
        }
      ],
      "pageMetadata": {
        "robots": {
          "index": false
        },
        "other": {
          "audience": "private"
        }
      },
      "prefix": "/react/overview/"
    },
    "Handbook": {
      "title": "React Handbook",
      "pages": [
        {
          "slug": "styling",
          "path": "./styling/page.mdx",
          "title": "Styling",
          "description": "A guide to styling Base UI components with your preferred styling engine.",
          "keywords": [
            "Base UI Styling",
            "Tailwind Base UI",
            "CSS Modules Base UI",
            "CSS-in-JS Base UI",
            "Style Hooks Data Attributes",
            "Unstyled React Components",
            "Handbook Styling",
            "Headless UI Styling",
            "Theming",
            "Custom Styles",
            "Utility First CSS",
            "Headless Components Styling"
          ],
          "sections": {
            "style-hooks": {
              "title": "Style hooks",
              "children": {
                "css-classes": {
                  "title": "CSS classes"
                },
                "data-attributes": {
                  "title": "Data attributes"
                },
                "css-variables": {
                  "title": "CSS variables"
                },
                "style-prop": {
                  "title": "Style prop"
                }
              }
            },
            "tailwind-css": {
              "title": "Tailwind CSS"
            },
            "css-modules": {
              "title": "CSS Modules"
            },
            "css-in-js": {
              "title": "CSS-in-JS"
            }
          }
        },
        {
          "slug": "animation",
          "path": "./animation/page.mdx",
          "title": "Animation",
          "description": "A guide to animating Base UI components.",
          "keywords": [
            "Base UI Animation",
            "React Component Animations",
            "CSS Transition Guide",
            "Motion Framer Integration",
            "Animation Data Attributes",
            "Handbook Animation",
            "Spring Animations",
            "Enter Exit Animations",
            "Transition Hooks",
            "Animated Components",
            "Keyframe Animations"
          ],
          "sections": {
            "css-transitions": {
              "title": "CSS transitions"
            },
            "css-animations": {
              "title": "CSS animations"
            },
            "javascript-animations": {
              "title": "JavaScript animations",
              "children": {
                "animating-components-unmounted-from-dom-when-closed-with-motion": {
                  "title": "Animating components unmounted from DOM when closed with Motion"
                },
                "animating-components-kept-in-dom-when-closed-with-motion": {
                  "title": "Animating components kept in DOM when closed with Motion"
                },
                "animating-select-component-with-motion": {
                  "title": "Animating Select component with Motion"
                },
                "manual-unmounting": {
                  "title": "Manual unmounting"
                }
              }
            }
          }
        },
        {
          "slug": "composition",
          "path": "./composition/page.mdx",
          "title": "Composition",
          "description": "A guide to composing Base UI components with your own React components.",
          "keywords": [
            "Base UI Composition",
            "React Render Prop",
            "Compose Headless Components",
            "Custom Trigger Render",
            "Nested Render Props",
            "Composition Handbook",
            "Component Composition",
            "Render Props Pattern",
            "Compound Components",
            "Polymorphic Components",
            "As Prop",
            "Custom Elements",
            "Wrapper Components"
          ],
          "sections": {
            "composing-custom-react-components": {
              "title": "Composing custom React components"
            },
            "composing-multiple-components": {
              "title": "Composing multiple components"
            },
            "changing-the-default-rendered-element": {
              "title": "Changing the default rendered element"
            },
            "render-function": {
              "title": "Render function"
            }
          }
        },
        {
          "slug": "customization",
          "path": "./customization/page.mdx",
          "title": "Customization",
          "description": "A guide to customizing the behavior of Base UI components.",
          "keywords": [
            "Base UI Customization",
            "React eventDetails",
            "Control Base UI State",
            "Cancel Base UI Events",
            "Allow Propagation Tooltip",
            "Customization Handbook",
            "Event Handlers",
            "Controlled Components",
            "Uncontrolled Components",
            "Component Behavior",
            "Event Callbacks",
            "State Management",
            "Component Props",
            "Override Behavior"
          ],
          "sections": {
            "base-ui-events": {
              "title": "Base UI events",
              "children": {
                "canceling-a-base-ui-event": {
                  "title": "Canceling a Base UI event"
                },
                "allowing-propagation-of-the-dom-event": {
                  "title": "Allowing propagation of the DOM event"
                }
              }
            },
            "preventing-base-ui-from-handling-a-react-event": {
              "title": "Preventing Base UI from handling a React event"
            },
            "controlling-components-with-state": {
              "title": "Controlling components with state"
            }
          }
        },
        {
          "slug": "forms",
          "path": "./forms/page.mdx",
          "title": "Forms",
          "description": "A guide to building forms with Base UI components.",
          "keywords": [
            "Base UI Forms",
            "React Accessible Forms",
            "Field Validation Handbook",
            "React Hook Form Integration",
            "TanStack Form Guide",
            "Constraint Validation API",
            "Handbook Forms",
            "Form State",
            "Form Library",
            "Form Handling",
            "Input Validation",
            "Error Messages",
            "Form Submission",
            "Accessible Forms",
            "ARIA Forms"
          ],
          "sections": {
            "naming-form-controls": {
              "title": "Naming form controls",
              "children": {
                "input-controls": {
                  "title": "Input controls"
                },
                "trigger-based-controls": {
                  "title": "Trigger-based controls"
                },
                "fallback": {
                  "title": "Fallback"
                },
                "describing-the-control": {
                  "title": "Describing the control"
                },
                "labeling-control-groups": {
                  "title": "Labeling control groups"
                }
              }
            },
            "building-form-fields": {
              "title": "Building form fields"
            },
            "submitting-data": {
              "title": "Submitting data"
            },
            "constraint-validation": {
              "title": "Constraint validation"
            },
            "custom-validation": {
              "title": "Custom validation"
            },
            "server-side-validation": {
              "title": "Server-side validation"
            },
            "displaying-errors": {
              "title": "Displaying errors"
            },
            "react-hook-form": {
              "title": "React Hook Form",
              "children": {
                "initialize-the-form": {
                  "title": "Initialize the form"
                },
                "integrate-components": {
                  "title": "Integrate components"
                },
                "field-validation": {
                  "title": "Field validation"
                },
                "submitting-data": {
                  "title": "Submitting data"
                }
              }
            },
            "tanstack-form": {
              "title": "TanStack Form",
              "children": {
                "initialize-the-form": {
                  "title": "Initialize the form"
                },
                "integrate-components": {
                  "title": "Integrate components"
                },
                "form-validation": {
                  "title": "Form validation"
                },
                "field-validation": {
                  "title": "Field validation"
                },
                "submitting-data": {
                  "title": "Submitting data"
                }
              }
            }
          }
        },
        {
          "slug": "typescript",
          "path": "./typescript/page.mdx",
          "title": "TypeScript",
          "description": "A guide to using TypeScript with Base UI.",
          "keywords": [
            "Base UI TypeScript",
            "Component Props Namespace",
            "Combobox ChangeEventDetails",
            "Popover Positioner State",
            "Toast Actions Ref Types",
            "Use Render Component Props",
            "Handbook TypeScript",
            "Type Definitions",
            "Type Safety",
            "Generics",
            "Component Types",
            "Props Types",
            "Event Types",
            "Ref Types",
            "Type Inference",
            "Strongly Typed Components"
          ],
          "sections": {
            "namespaces": {
              "title": "Namespaces",
              "children": {
                "props": {
                  "title": "Props"
                },
                "state": {
                  "title": "State"
                },
                "events": {
                  "title": "Events"
                },
                "other-accessible-types": {
                  "title": "Other accessible types"
                }
              }
            }
          }
        },
        {
          "slug": "llms-txt",
          "path": "/llms.txt",
          "title": "llms.txt",
          "description": "No description available",
          "tags": [
            "External"
          ],
          "skipDetailSection": true
        }
      ],
      "pageMetadata": {
        "robots": {
          "index": false
        },
        "other": {
          "audience": "private"
        }
      },
      "prefix": "/react/handbook/"
    },
    "Components": {
      "title": "React Components",
      "pages": [
        {
          "slug": "accordion",
          "path": "./accordion/page.mdx",
          "title": "Accordion",
          "description": "A set of collapsible panels with headings.",
          "keywords": [
            "React Accordion",
            "Accordion Component",
            "Collapsible Content",
            "Expandable Panel",
            "Accessible Accordion",
            "Multi-Panel UI",
            "Disclosure Widget",
            "FAQ Component",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "defaultValue",
                "disabled",
                "hiddenUntilFound",
                "keepMounted",
                "loopFocus",
                "multiple",
                "onValueChange",
                "orientation",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-orientation"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-panel-open"
              ]
            },
            "Item": {
              "props": [
                "className",
                "disabled",
                "onOpenChange",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-index",
                "data-open"
              ]
            },
            "Header": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-index",
                "data-open"
              ]
            },
            "Panel": {
              "props": [
                "className",
                "hiddenUntilFound",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-ending-style",
                "data-index",
                "data-open",
                "data-orientation",
                "data-starting-style"
              ],
              "cssVariables": [
                "--accordion-panel-height",
                "--accordion-panel-width"
              ]
            }
          },
          "types": [
            "Accordion.Header.Props",
            "Accordion.Header.State",
            "Accordion.Item.ChangeEventDetails",
            "Accordion.Item.ChangeEventReason",
            "Accordion.Item.Props",
            "Accordion.Item.State",
            "Accordion.Panel.Props",
            "Accordion.Panel.State",
            "Accordion.Root.ChangeEventDetails",
            "Accordion.Root.ChangeEventReason",
            "Accordion.Root.Props",
            "Accordion.Root.State",
            "Accordion.Root.Value",
            "Accordion.Trigger.Props",
            "Accordion.Trigger.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "open-multiple-panels": {
                  "title": "Open multiple panels"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "item": {
                  "title": "Item"
                },
                "header": {
                  "title": "Header"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "panel": {
                  "title": "Panel"
                }
              }
            }
          }
        },
        {
          "slug": "alert-dialog",
          "path": "./alert-dialog/page.mdx",
          "title": "Alert Dialog",
          "description": "A dialog that requires a user response to proceed.",
          "keywords": [
            "React Alert Dialog",
            "Alert Dialog Component",
            "Confirmation Modal",
            "Warning Dialog",
            "Blocking Modal",
            "Interrupt Dialog",
            "Destructive Action Confirm",
            "Accessible Dialog",
            "Headless React Components",
            "React UI Overlay",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "children",
                "defaultOpen",
                "defaultTriggerId",
                "handle",
                "onOpenChange",
                "onOpenChangeComplete",
                "open",
                "triggerId"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "handle",
                "id",
                "nativeButton",
                "payload",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-popup-open"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "forceRender",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Popup": {
              "props": [
                "className",
                "finalFocus",
                "initialFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-nested",
                "data-nested-dialog-open",
                "data-open",
                "data-starting-style"
              ],
              "cssVariables": [
                "--nested-dialogs"
              ]
            },
            "Title": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Description": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Close": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled"
              ]
            },
            "Viewport": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-nested",
                "data-nested-dialog-open",
                "data-open",
                "data-starting-style"
              ]
            },
            "createHandle": {},
            "Handle": {
              "parameters": [
                "store"
              ]
            }
          },
          "types": [
            "AlertDialog.Backdrop.Props",
            "AlertDialog.Backdrop.State",
            "AlertDialog.Close.Props",
            "AlertDialog.Close.State",
            "AlertDialog.Description.Props",
            "AlertDialog.Description.State",
            "AlertDialog.Popup.Props",
            "AlertDialog.Popup.State",
            "AlertDialog.Portal.Props",
            "AlertDialog.Portal.State",
            "AlertDialog.Root.Actions",
            "AlertDialog.Root.ChangeEventDetails",
            "AlertDialog.Root.ChangeEventReason",
            "AlertDialog.Root.Props",
            "AlertDialog.Root.State",
            "AlertDialog.Title.Props",
            "AlertDialog.Title.State",
            "AlertDialog.Trigger.Props",
            "AlertDialog.Trigger.State",
            "AlertDialog.Viewport.Props",
            "AlertDialog.Viewport.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "open-from-a-menu": {
                  "title": "Open from a menu"
                },
                "close-confirmation": {
                  "title": "Close confirmation"
                },
                "detached-triggers": {
                  "title": "Detached triggers"
                },
                "multiple-triggers": {
                  "title": "Multiple triggers"
                },
                "controlled-mode-with-multiple-triggers": {
                  "title": "Controlled mode with multiple triggers"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "portal": {
                  "title": "Portal"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "viewport": {
                  "title": "Viewport"
                },
                "popup": {
                  "title": "Popup"
                },
                "title": {
                  "title": "Title"
                },
                "description": {
                  "title": "Description"
                },
                "close": {
                  "title": "Close"
                }
              }
            },
            "createhandle": {
              "title": "createHandle",
              "children": {
                "handle": {
                  "title": "Handle"
                }
              }
            }
          }
        },
        {
          "slug": "autocomplete",
          "path": "./autocomplete/page.mdx",
          "title": "Autocomplete",
          "description": "An input that suggests options as you type.",
          "keywords": [
            "React Autocomplete",
            "Autocomplete Component",
            "Search Suggestions",
            "Filterable Input",
            "Async Autocomplete",
            "Typeahead",
            "Lookahead",
            "Autosuggest",
            "Incremental Search",
            "Predictive Text",
            "Search Input",
            "Accessible Combobox",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "autoHighlight",
                "children",
                "defaultOpen",
                "defaultValue",
                "disabled",
                "filter",
                "filteredItems",
                "form",
                "grid",
                "highlightItemOnHover",
                "id",
                "inline",
                "inputRef",
                "itemToStringValue",
                "items",
                "keepHighlight",
                "limit",
                "locale",
                "loopFocus",
                "modal",
                "mode",
                "name",
                "onItemHighlighted",
                "onOpenChange",
                "onOpenChangeComplete",
                "onValueChange",
                "open",
                "openOnInputClick",
                "readOnly",
                "required",
                "submitOnItemClick",
                "value",
                "virtualized"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "disabled",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-list-empty",
                "data-popup-open",
                "data-popup-side",
                "data-pressed",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-valid"
              ]
            },
            "Value": {
              "props": [
                "children"
              ]
            },
            "Input": {
              "props": [
                "className",
                "disabled",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-list-empty",
                "data-popup-open",
                "data-popup-side",
                "data-pressed",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-valid"
              ]
            },
            "Icon": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Clear": {
              "props": [
                "className",
                "disabled",
                "keepMounted",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-ending-style",
                "data-popup-open",
                "data-starting-style",
                "data-visible"
              ]
            },
            "List": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-closed",
                "data-empty",
                "data-open",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--transform-origin"
              ]
            },
            "Popup": {
              "props": [
                "className",
                "finalFocus",
                "initialFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-empty",
                "data-ending-style",
                "data-instant",
                "data-open",
                "data-side",
                "data-starting-style"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-open",
                "data-side",
                "data-uncentered"
              ]
            },
            "Item": {
              "props": [
                "children",
                "className",
                "disabled",
                "index",
                "nativeButton",
                "onClick",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-highlighted"
              ]
            },
            "Group": {
              "props": [
                "className",
                "items",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-list-empty",
                "data-popup-open",
                "data-popup-side",
                "data-pressed",
                "data-readonly",
                "data-touched",
                "data-valid"
              ]
            },
            "GroupLabel": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Separator": {
              "props": [
                "className",
                "orientation",
                "render",
                "style"
              ]
            },
            "Status": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Empty": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Collection": {
              "props": [
                "children"
              ]
            },
            "Row": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "InputGroup": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-list-empty",
                "data-popup-open",
                "data-popup-side",
                "data-pressed",
                "data-readonly",
                "data-touched",
                "data-valid"
              ]
            },
            "useFilter": {
              "parameters": [
                "options"
              ]
            },
            "useFilteredItems": {}
          },
          "types": [
            "Autocomplete.Arrow.Props",
            "Autocomplete.Arrow.State",
            "Autocomplete.Backdrop.Props",
            "Autocomplete.Backdrop.State",
            "Autocomplete.Clear.Props",
            "Autocomplete.Clear.State",
            "Autocomplete.Collection.Props",
            "Autocomplete.Collection.State",
            "Autocomplete.Empty.Props",
            "Autocomplete.Empty.State",
            "Autocomplete.Group.Props",
            "Autocomplete.Group.State",
            "Autocomplete.GroupLabel.Props",
            "Autocomplete.GroupLabel.State",
            "Autocomplete.Icon.Props",
            "Autocomplete.Icon.State",
            "Autocomplete.Input.Props",
            "Autocomplete.Input.State",
            "Autocomplete.InputGroup.Props",
            "Autocomplete.InputGroup.State",
            "Autocomplete.Item.Props",
            "Autocomplete.Item.State",
            "Autocomplete.List.Props",
            "Autocomplete.List.State",
            "Autocomplete.Popup.Props",
            "Autocomplete.Popup.State",
            "Autocomplete.Portal.Props",
            "Autocomplete.Portal.State",
            "Autocomplete.Positioner.Props",
            "Autocomplete.Positioner.State",
            "Autocomplete.Root.Actions",
            "Autocomplete.Root.ChangeEventDetails",
            "Autocomplete.Root.ChangeEventReason",
            "Autocomplete.Root.HighlightEventDetails",
            "Autocomplete.Root.HighlightEventReason",
            "Autocomplete.Root.Props",
            "Autocomplete.Root.State",
            "Autocomplete.Row.Props",
            "Autocomplete.Row.State",
            "Autocomplete.Separator.Props",
            "Autocomplete.Separator.State",
            "Autocomplete.Status.Props",
            "Autocomplete.Status.State",
            "Autocomplete.Trigger.Props",
            "Autocomplete.Trigger.State",
            "Autocomplete.Value.Props",
            "Autocomplete.Value.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "typescript-inference": {
              "title": "TypeScript inference"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "async-search": {
                  "title": "Async search"
                },
                "inline-autocomplete": {
                  "title": "Inline autocomplete"
                },
                "grouped": {
                  "title": "Grouped"
                },
                "fuzzy-matching": {
                  "title": "Fuzzy matching"
                },
                "limit-results": {
                  "title": "Limit results"
                },
                "auto-highlight": {
                  "title": "Auto highlight"
                },
                "command-palette": {
                  "title": "Command palette"
                },
                "grid-layout": {
                  "title": "Grid layout"
                },
                "virtualized": {
                  "title": "Virtualized"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "value": {
                  "title": "Value"
                },
                "input": {
                  "title": "Input"
                },
                "inputgroup": {
                  "title": "InputGroup"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "icon": {
                  "title": "Icon"
                },
                "clear": {
                  "title": "Clear"
                },
                "list": {
                  "title": "List"
                },
                "portal": {
                  "title": "Portal"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "popup": {
                  "title": "Popup"
                },
                "arrow": {
                  "title": "Arrow"
                },
                "status": {
                  "title": "Status"
                },
                "empty": {
                  "title": "Empty"
                },
                "collection": {
                  "title": "Collection"
                },
                "row": {
                  "title": "Row"
                },
                "item": {
                  "title": "Item"
                },
                "group": {
                  "title": "Group"
                },
                "grouplabel": {
                  "title": "GroupLabel"
                },
                "separator": {
                  "title": "Separator"
                }
              }
            },
            "usefilter": {
              "title": "useFilter"
            },
            "usefiltereditems": {
              "title": "useFilteredItems"
            }
          }
        },
        {
          "slug": "avatar",
          "path": "./avatar/page.mdx",
          "title": "Avatar",
          "description": "An easily stylable avatar component.",
          "keywords": [
            "React Avatar",
            "Avatar Component",
            "Profile Image UI",
            "User Image",
            "User Avatar",
            "Profile Picture",
            "Account Image",
            "Profile Icon",
            "Initials Fallback",
            "Accessible Avatar",
            "Headless React Components",
            "Customizable Avatar",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Image": {
              "props": [
                "className",
                "onLoadingStatusChange",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-ending-style",
                "data-starting-style"
              ]
            },
            "Fallback": {
              "props": [
                "className",
                "delay",
                "render",
                "style"
              ]
            }
          },
          "types": [
            "Avatar.Fallback.Props",
            "Avatar.Fallback.State",
            "Avatar.Image.Props",
            "Avatar.Image.State",
            "Avatar.Root.Props",
            "Avatar.Root.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "image": {
                  "title": "Image"
                },
                "fallback": {
                  "title": "Fallback"
                }
              }
            }
          }
        },
        {
          "slug": "button",
          "path": "./button/page.mdx",
          "title": "Button",
          "description": "A button component that can be rendered as another tag or focusable when disabled.",
          "keywords": [
            "React Button",
            "Button Component",
            "Focusable Disabled Button",
            "Custom Element Button",
            "Clickable Element",
            "Action Button",
            "Submit Button",
            "Accessible Button",
            "Loading State Button",
            "Button as Link",
            "Link Button",
            "Headless React Components",
            "Base UI"
          ],
          "exports": {
            "Button": {
              "props": [
                "className",
                "focusableWhenDisabled",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled"
              ]
            }
          },
          "types": [
            "Button.Props",
            "Button.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "rendering-as-another-tag": {
                  "title": "Rendering as another tag"
                },
                "rendering-links-as-buttons": {
                  "title": "Rendering links as buttons"
                },
                "loading-states": {
                  "title": "Loading states"
                }
              }
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        },
        {
          "slug": "checkbox",
          "path": "./checkbox/page.mdx",
          "title": "Checkbox",
          "description": "An easily stylable checkbox component.",
          "keywords": [
            "React Checkbox",
            "Checkbox Component",
            "Accessible Checkbox",
            "Customizable Checkbox",
            "Form Control Checkbox",
            "Checkmark",
            "Tick Box",
            "Selection Control",
            "Checkbox Input",
            "Binary Input",
            "Checked State",
            "Indeterminate Checkbox",
            "Tri-State Checkbox",
            "Headless React Components",
            "Input Indicator",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "checked",
                "className",
                "defaultChecked",
                "disabled",
                "form",
                "id",
                "indeterminate",
                "inputRef",
                "name",
                "nativeButton",
                "onCheckedChange",
                "parent",
                "readOnly",
                "render",
                "required",
                "style",
                "uncheckedValue",
                "value"
              ],
              "dataAttributes": [
                "data-checked",
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-indeterminate",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-unchecked",
                "data-valid"
              ]
            },
            "Indicator": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-checked",
                "data-dirty",
                "data-disabled",
                "data-ending-style",
                "data-filled",
                "data-focused",
                "data-indeterminate",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-starting-style",
                "data-touched",
                "data-unchecked",
                "data-valid"
              ]
            }
          },
          "types": [
            "Checkbox.Indicator.Props",
            "Checkbox.Indicator.State",
            "Checkbox.Root.ChangeEventDetails",
            "Checkbox.Root.ChangeEventReason",
            "Checkbox.Root.Props",
            "Checkbox.Root.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "labeling-a-checkbox": {
                  "title": "Labeling a checkbox"
                },
                "rendering-as-a-native-button": {
                  "title": "Rendering as a native button"
                },
                "form-integration": {
                  "title": "Form integration"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "indicator": {
                  "title": "Indicator"
                }
              }
            }
          }
        },
        {
          "slug": "checkbox-group",
          "path": "./checkbox-group/page.mdx",
          "title": "Checkbox Group",
          "description": "Provides shared state to a series of checkboxes.",
          "keywords": [
            "React Checkbox Group",
            "Checkbox Group Component",
            "Grouped Checkboxes",
            "Multiple Selection",
            "Checkbox List",
            "Multi-Select Checkboxes",
            "Parent Child Checkbox",
            "Accessible Checkbox Group",
            "Form Fieldset Control",
            "Headless React Components",
            "Base UI"
          ],
          "exports": {
            "CheckboxGroup": {
              "props": [
                "allValues",
                "className",
                "defaultValue",
                "disabled",
                "onValueChange",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-disabled"
              ]
            }
          },
          "types": [
            "CheckboxGroup.ChangeEventDetails",
            "CheckboxGroup.ChangeEventReason",
            "CheckboxGroup.Props",
            "CheckboxGroup.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "labeling-a-checkbox-group": {
                  "title": "Labeling a checkbox group"
                },
                "rendering-as-a-native-button": {
                  "title": "Rendering as a native button"
                },
                "form-integration": {
                  "title": "Form integration"
                },
                "parent-checkbox": {
                  "title": "Parent checkbox"
                },
                "nested-parent-checkbox": {
                  "title": "Nested parent checkbox"
                }
              }
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        },
        {
          "slug": "collapsible",
          "path": "./collapsible/page.mdx",
          "title": "Collapsible",
          "description": "A collapsible panel controlled by a button.",
          "keywords": [
            "React Collapsible",
            "Collapsible Component",
            "Expandable Panel",
            "Toggle Panel Button",
            "Disclosure Widget",
            "Show/Hide Content",
            "Accordion Item",
            "Accessible Disclosure",
            "Headless React Components",
            "Collapsible Trigger Panel",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "defaultOpen",
                "disabled",
                "onOpenChange",
                "open",
                "render",
                "style"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-panel-open"
              ]
            },
            "Panel": {
              "props": [
                "className",
                "hiddenUntilFound",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ],
              "cssVariables": [
                "--collapsible-panel-height",
                "--collapsible-panel-width"
              ]
            }
          },
          "types": [
            "Collapsible.Panel.Props",
            "Collapsible.Panel.State",
            "Collapsible.Root.ChangeEventDetails",
            "Collapsible.Root.ChangeEventReason",
            "Collapsible.Root.Props",
            "Collapsible.Root.State",
            "Collapsible.Trigger.Props",
            "Collapsible.Trigger.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "panel": {
                  "title": "Panel"
                }
              }
            }
          }
        },
        {
          "slug": "combobox",
          "path": "./combobox/page.mdx",
          "title": "Combobox",
          "description": "An input combined with a list of predefined items to select.",
          "keywords": [
            "React Combobox",
            "Combobox Component",
            "Combo Box",
            "Filterable Select",
            "Searchable Dropdown",
            "Editable Select",
            "Typeahead Select",
            "Autocomplete Dropdown",
            "Tags Input",
            "Chip Input",
            "Token Input",
            "Multi-Value Input",
            "Multiple Select Combobox",
            "Async Combobox",
            "Accessible Combobox",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "autoComplete",
                "autoHighlight",
                "children",
                "defaultInputValue",
                "defaultOpen",
                "defaultValue",
                "disabled",
                "filter",
                "filteredItems",
                "form",
                "grid",
                "highlightItemOnHover",
                "id",
                "inline",
                "inputRef",
                "inputValue",
                "isItemEqualToValue",
                "itemToStringLabel",
                "itemToStringValue",
                "items",
                "limit",
                "locale",
                "loopFocus",
                "modal",
                "multiple",
                "name",
                "onInputValueChange",
                "onItemHighlighted",
                "onOpenChange",
                "onOpenChangeComplete",
                "onValueChange",
                "open",
                "openOnInputClick",
                "readOnly",
                "required",
                "value",
                "virtualized"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "disabled",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-list-empty",
                "data-placeholder",
                "data-popup-open",
                "data-popup-side",
                "data-pressed",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-valid"
              ]
            },
            "Value": {
              "props": [
                "children",
                "placeholder"
              ]
            },
            "Input": {
              "props": [
                "className",
                "disabled",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-list-empty",
                "data-popup-open",
                "data-popup-side",
                "data-pressed",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-valid"
              ]
            },
            "Icon": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Clear": {
              "props": [
                "className",
                "disabled",
                "keepMounted",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-ending-style",
                "data-popup-open",
                "data-starting-style",
                "data-visible"
              ]
            },
            "List": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-closed",
                "data-empty",
                "data-open",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--transform-origin"
              ]
            },
            "Popup": {
              "props": [
                "className",
                "finalFocus",
                "initialFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-empty",
                "data-ending-style",
                "data-instant",
                "data-open",
                "data-side",
                "data-starting-style"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-open",
                "data-side",
                "data-uncentered"
              ]
            },
            "Item": {
              "props": [
                "children",
                "className",
                "disabled",
                "index",
                "nativeButton",
                "onClick",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-highlighted",
                "data-selected"
              ]
            },
            "Group": {
              "props": [
                "className",
                "items",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-list-empty",
                "data-placeholder",
                "data-popup-open",
                "data-popup-side",
                "data-pressed",
                "data-readonly",
                "data-touched",
                "data-valid"
              ]
            },
            "GroupLabel": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Separator": {
              "props": [
                "className",
                "orientation",
                "render",
                "style"
              ]
            },
            "Label": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Status": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Empty": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Collection": {
              "props": [
                "children"
              ]
            },
            "Row": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Chips": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Chip": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "ChipRemove": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ]
            },
            "ItemIndicator": {
              "props": [
                "children",
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-ending-style",
                "data-starting-style"
              ]
            },
            "InputGroup": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-list-empty",
                "data-placeholder",
                "data-popup-open",
                "data-popup-side",
                "data-pressed",
                "data-readonly",
                "data-touched",
                "data-valid"
              ]
            },
            "useFilter": {
              "parameters": [
                "options"
              ]
            },
            "useFilteredItems": {}
          },
          "types": [
            "Combobox.Arrow.Props",
            "Combobox.Arrow.State",
            "Combobox.Backdrop.Props",
            "Combobox.Backdrop.State",
            "Combobox.Chip.Props",
            "Combobox.Chip.State",
            "Combobox.ChipRemove.Props",
            "Combobox.ChipRemove.State",
            "Combobox.Chips.Props",
            "Combobox.Chips.State",
            "Combobox.Clear.Props",
            "Combobox.Clear.State",
            "Combobox.Collection.Props",
            "Combobox.Collection.State",
            "Combobox.Empty.Props",
            "Combobox.Empty.State",
            "Combobox.Group.Props",
            "Combobox.Group.State",
            "Combobox.GroupLabel.Props",
            "Combobox.GroupLabel.State",
            "Combobox.Icon.Props",
            "Combobox.Icon.State",
            "Combobox.Input.Props",
            "Combobox.Input.State",
            "Combobox.InputGroup.Props",
            "Combobox.InputGroup.State",
            "Combobox.Item.Props",
            "Combobox.Item.State",
            "Combobox.ItemIndicator.Props",
            "Combobox.ItemIndicator.State",
            "Combobox.Label.Props",
            "Combobox.Label.State",
            "Combobox.List.Props",
            "Combobox.List.State",
            "Combobox.Popup.Props",
            "Combobox.Popup.State",
            "Combobox.Portal.Props",
            "Combobox.Portal.State",
            "Combobox.Positioner.Props",
            "Combobox.Positioner.State",
            "Combobox.Root.Actions",
            "Combobox.Root.ChangeEventDetails",
            "Combobox.Root.ChangeEventReason",
            "Combobox.Root.HighlightEventDetails",
            "Combobox.Root.HighlightEventReason",
            "Combobox.Root.Props",
            "Combobox.Root.State",
            "Combobox.Row.Props",
            "Combobox.Row.State",
            "Combobox.Separator.Props",
            "Combobox.Separator.State",
            "Combobox.Status.Props",
            "Combobox.Status.State",
            "Combobox.Trigger.Props",
            "Combobox.Trigger.State",
            "Combobox.Value.Props",
            "Combobox.Value.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "typescript": {
              "title": "TypeScript"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "typed-wrapper-component": {
                  "title": "Typed wrapper component"
                },
                "multiple-select": {
                  "title": "Multiple select"
                },
                "input-inside-popup": {
                  "title": "Input inside popup"
                },
                "grouped": {
                  "title": "Grouped"
                },
                "async-search-single": {
                  "title": "Async search (single)"
                },
                "async-search-multiple": {
                  "title": "Async search (multiple)"
                },
                "creatable": {
                  "title": "Creatable"
                },
                "virtualized": {
                  "title": "Virtualized"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "label": {
                  "title": "Label"
                },
                "value": {
                  "title": "Value"
                },
                "icon": {
                  "title": "Icon"
                },
                "input": {
                  "title": "Input"
                },
                "inputgroup": {
                  "title": "InputGroup"
                },
                "clear": {
                  "title": "Clear"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "chips": {
                  "title": "Chips"
                },
                "chip": {
                  "title": "Chip"
                },
                "chipremove": {
                  "title": "ChipRemove"
                },
                "list": {
                  "title": "List"
                },
                "portal": {
                  "title": "Portal"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "popup": {
                  "title": "Popup"
                },
                "arrow": {
                  "title": "Arrow"
                },
                "status": {
                  "title": "Status"
                },
                "empty": {
                  "title": "Empty"
                },
                "collection": {
                  "title": "Collection"
                },
                "row": {
                  "title": "Row"
                },
                "item": {
                  "title": "Item"
                },
                "itemindicator": {
                  "title": "ItemIndicator"
                },
                "group": {
                  "title": "Group"
                },
                "grouplabel": {
                  "title": "GroupLabel"
                },
                "separator": {
                  "title": "Separator"
                }
              }
            },
            "usefilter": {
              "title": "useFilter"
            },
            "usefiltereditems": {
              "title": "useFilteredItems"
            }
          }
        },
        {
          "slug": "context-menu",
          "path": "./context-menu/page.mdx",
          "title": "Context Menu",
          "description": "A menu that appears at the pointer on right click or long press.",
          "keywords": [
            "React Context Menu",
            "Context Menu Component",
            "Right Click Menu",
            "Secondary Click Menu",
            "Pointer Menu",
            "Touch Hold Menu",
            "Long Press Menu",
            "Nested Menu React",
            "Accessible Context Menu",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "children",
                "closeParentOnEsc",
                "defaultOpen",
                "defaultTriggerId",
                "disabled",
                "handle",
                "highlightItemOnHover",
                "loopFocus",
                "onOpenChange",
                "onOpenChangeComplete",
                "open",
                "orientation",
                "triggerId"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-popup-open",
                "data-pressed"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-closed",
                "data-open",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--transform-origin"
              ]
            },
            "Popup": {
              "props": [
                "children",
                "className",
                "finalFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-ending-style",
                "data-instant",
                "data-open",
                "data-side",
                "data-starting-style"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-open",
                "data-side",
                "data-uncentered"
              ]
            },
            "Item": {
              "props": [
                "className",
                "closeOnClick",
                "disabled",
                "label",
                "nativeButton",
                "onClick",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-highlighted"
              ]
            },
            "Group": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ]
            },
            "GroupLabel": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Separator": {
              "props": [
                "className",
                "orientation",
                "render",
                "style"
              ]
            },
            "SubmenuRoot": {
              "props": [
                "actionsRef",
                "children",
                "closeParentOnEsc",
                "defaultOpen",
                "defaultTriggerId",
                "disabled",
                "handle",
                "highlightItemOnHover",
                "loopFocus",
                "onOpenChange",
                "onOpenChangeComplete",
                "open",
                "orientation",
                "triggerId"
              ]
            },
            "SubmenuTrigger": {
              "props": [
                "className",
                "closeDelay",
                "delay",
                "disabled",
                "label",
                "nativeButton",
                "onClick",
                "openOnHover",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-highlighted",
                "data-popup-open"
              ]
            },
            "RadioGroup": {
              "props": [
                "children",
                "className",
                "defaultValue",
                "disabled",
                "onValueChange",
                "render",
                "style",
                "value"
              ]
            },
            "RadioItem": {
              "props": [
                "className",
                "closeOnClick",
                "disabled",
                "label",
                "nativeButton",
                "onClick",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-checked",
                "data-disabled",
                "data-highlighted",
                "data-unchecked"
              ]
            },
            "RadioItemIndicator": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-checked",
                "data-disabled",
                "data-ending-style",
                "data-starting-style",
                "data-unchecked"
              ]
            },
            "CheckboxItem": {
              "props": [
                "checked",
                "className",
                "closeOnClick",
                "defaultChecked",
                "disabled",
                "label",
                "nativeButton",
                "onCheckedChange",
                "onClick",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-checked",
                "data-disabled",
                "data-highlighted",
                "data-unchecked"
              ]
            },
            "CheckboxItemIndicator": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-checked",
                "data-disabled",
                "data-ending-style",
                "data-starting-style",
                "data-unchecked"
              ]
            },
            "LinkItem": {
              "props": [
                "className",
                "closeOnClick",
                "label",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-highlighted"
              ]
            }
          },
          "types": [
            "ContextMenu.Arrow.Props",
            "ContextMenu.Arrow.State",
            "ContextMenu.Backdrop.Props",
            "ContextMenu.Backdrop.State",
            "ContextMenu.CheckboxItem.ChangeEventDetails",
            "ContextMenu.CheckboxItem.ChangeEventReason",
            "ContextMenu.CheckboxItem.Props",
            "ContextMenu.CheckboxItem.State",
            "ContextMenu.CheckboxItemIndicator.Props",
            "ContextMenu.CheckboxItemIndicator.State",
            "ContextMenu.Group.Props",
            "ContextMenu.Group.State",
            "ContextMenu.GroupLabel.Props",
            "ContextMenu.GroupLabel.State",
            "ContextMenu.Item.Props",
            "ContextMenu.Item.State",
            "ContextMenu.LinkItem.Props",
            "ContextMenu.LinkItem.State",
            "ContextMenu.Popup.Props",
            "ContextMenu.Popup.State",
            "ContextMenu.Portal.Props",
            "ContextMenu.Portal.State",
            "ContextMenu.Positioner.Props",
            "ContextMenu.Positioner.State",
            "ContextMenu.RadioGroup.ChangeEventDetails",
            "ContextMenu.RadioGroup.ChangeEventReason",
            "ContextMenu.RadioGroup.Props",
            "ContextMenu.RadioGroup.State",
            "ContextMenu.RadioItem.Props",
            "ContextMenu.RadioItem.State",
            "ContextMenu.RadioItemIndicator.Props",
            "ContextMenu.RadioItemIndicator.State",
            "ContextMenu.Root.Actions",
            "ContextMenu.Root.ChangeEventDetails",
            "ContextMenu.Root.ChangeEventReason",
            "ContextMenu.Root.Props",
            "ContextMenu.Root.State",
            "ContextMenu.Separator.Props",
            "ContextMenu.Separator.State",
            "ContextMenu.SubmenuRoot.ChangeEventDetails",
            "ContextMenu.SubmenuRoot.ChangeEventReason",
            "ContextMenu.SubmenuRoot.Props",
            "ContextMenu.SubmenuRoot.State",
            "ContextMenu.SubmenuTrigger.Props",
            "ContextMenu.SubmenuTrigger.State",
            "ContextMenu.Trigger.Props",
            "ContextMenu.Trigger.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "nested-menu": {
                  "title": "Nested menu"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "portal": {
                  "title": "Portal"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "popup": {
                  "title": "Popup"
                },
                "arrow": {
                  "title": "Arrow"
                },
                "item": {
                  "title": "Item"
                },
                "linkitem": {
                  "title": "LinkItem"
                },
                "submenuroot": {
                  "title": "SubmenuRoot"
                },
                "submenutrigger": {
                  "title": "SubmenuTrigger"
                },
                "group": {
                  "title": "Group"
                },
                "grouplabel": {
                  "title": "GroupLabel"
                },
                "radiogroup": {
                  "title": "RadioGroup"
                },
                "radioitem": {
                  "title": "RadioItem"
                },
                "radioitemindicator": {
                  "title": "RadioItemIndicator"
                },
                "checkboxitem": {
                  "title": "CheckboxItem"
                },
                "checkboxitemindicator": {
                  "title": "CheckboxItemIndicator"
                },
                "separator": {
                  "title": "Separator"
                }
              }
            }
          }
        },
        {
          "slug": "dialog",
          "path": "./dialog/page.mdx",
          "title": "Dialog",
          "description": "A popup that opens on top of the entire page.",
          "keywords": [
            "React Dialog",
            "Modal Dialog Component",
            "Modal Popup",
            "Modal Window",
            "Popup Window",
            "Modal Overlay",
            "Overlay",
            "Lightbox",
            "Popover Dialog",
            "Controlled Dialog State",
            "Nested Dialog React",
            "Focus Trap Dialog",
            "Accessible Dialog",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "children",
                "defaultOpen",
                "defaultTriggerId",
                "disablePointerDismissal",
                "handle",
                "modal",
                "onOpenChange",
                "onOpenChangeComplete",
                "open",
                "triggerId"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "handle",
                "id",
                "nativeButton",
                "payload",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-popup-open"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "forceRender",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Popup": {
              "props": [
                "className",
                "finalFocus",
                "initialFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-nested",
                "data-nested-dialog-open",
                "data-open",
                "data-starting-style"
              ],
              "cssVariables": [
                "--nested-dialogs"
              ]
            },
            "Title": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Description": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Close": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled"
              ]
            },
            "Viewport": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-nested",
                "data-nested-dialog-open",
                "data-open",
                "data-starting-style"
              ]
            },
            "createHandle": {},
            "Handle": {
              "parameters": [
                "store"
              ]
            }
          },
          "types": [
            "Dialog.Backdrop.Props",
            "Dialog.Backdrop.State",
            "Dialog.Close.Props",
            "Dialog.Close.State",
            "Dialog.Description.Props",
            "Dialog.Description.State",
            "Dialog.Popup.Props",
            "Dialog.Popup.State",
            "Dialog.Portal.Props",
            "Dialog.Portal.State",
            "Dialog.Root.Actions",
            "Dialog.Root.ChangeEventDetails",
            "Dialog.Root.ChangeEventReason",
            "Dialog.Root.Props",
            "Dialog.Root.State",
            "Dialog.Title.Props",
            "Dialog.Title.State",
            "Dialog.Trigger.Props",
            "Dialog.Trigger.State",
            "Dialog.Viewport.Props",
            "Dialog.Viewport.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "state": {
                  "title": "State"
                },
                "open-from-a-menu": {
                  "title": "Open from a menu"
                },
                "nested-dialogs": {
                  "title": "Nested dialogs"
                },
                "close-confirmation": {
                  "title": "Close confirmation"
                },
                "outside-scroll-dialog": {
                  "title": "Outside scroll dialog"
                },
                "inside-scroll-dialog": {
                  "title": "Inside scroll dialog"
                },
                "placing-elements-outside-the-popup": {
                  "title": "Placing elements outside the popup"
                },
                "detached-triggers": {
                  "title": "Detached triggers"
                },
                "multiple-triggers": {
                  "title": "Multiple triggers"
                },
                "controlled-mode-with-multiple-triggers": {
                  "title": "Controlled mode with multiple triggers"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "portal": {
                  "title": "Portal"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "viewport": {
                  "title": "Viewport"
                },
                "popup": {
                  "title": "Popup"
                },
                "title": {
                  "title": "Title"
                },
                "description": {
                  "title": "Description"
                },
                "close": {
                  "title": "Close"
                }
              }
            },
            "createhandle": {
              "title": "createHandle",
              "children": {
                "handle": {
                  "title": "Handle"
                }
              }
            }
          }
        },
        {
          "slug": "drawer",
          "path": "./drawer/page.mdx",
          "title": "Drawer",
          "description": "A panel that slides in from the edge of the screen.",
          "keywords": [
            "React Drawer",
            "Drawer Component",
            "Side Panel",
            "Bottom Sheet",
            "Swipe Dismiss Drawer",
            "Offcanvas",
            "Sliding Panel",
            "Modal Drawer",
            "Controlled Drawer State",
            "Accessible Drawer",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "children",
                "defaultOpen",
                "defaultSnapPoint",
                "defaultTriggerId",
                "disablePointerDismissal",
                "handle",
                "modal",
                "onOpenChange",
                "onOpenChangeComplete",
                "onSnapPointChange",
                "open",
                "snapPoint",
                "snapPoints",
                "snapToSequentialPoints",
                "swipeDirection",
                "triggerId"
              ]
            },
            "Provider": {
              "props": [
                "children"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "handle",
                "id",
                "nativeButton",
                "payload",
                "render",
                "style"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "forceRender",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ],
              "cssVariables": [
                "--drawer-swipe-progress"
              ]
            },
            "Popup": {
              "props": [
                "className",
                "finalFocus",
                "initialFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-expanded",
                "data-nested-drawer-open",
                "data-nested-drawer-swiping",
                "data-open",
                "data-starting-style",
                "data-swipe-direction",
                "data-swipe-dismiss",
                "data-swiping"
              ],
              "cssVariables": [
                "--drawer-frontmost-height",
                "--drawer-height",
                "--drawer-snap-point-offset",
                "--drawer-swipe-movement-x",
                "--drawer-swipe-movement-y",
                "--drawer-swipe-strength",
                "--nested-drawers"
              ]
            },
            "Content": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Title": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Description": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Close": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ]
            },
            "Viewport": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-nested",
                "data-open",
                "data-starting-style"
              ]
            },
            "createHandle": {},
            "Handle": {
              "parameters": [
                "store"
              ]
            },
            "Indent": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "IndentBackground": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "SwipeArea": {
              "props": [
                "className",
                "disabled",
                "render",
                "style",
                "swipeDirection"
              ],
              "dataAttributes": [
                "data-closed",
                "data-disabled",
                "data-open",
                "data-swipe-direction",
                "data-swiping"
              ]
            }
          },
          "types": [
            "Drawer.Backdrop.Props",
            "Drawer.Backdrop.State",
            "Drawer.Close.Props",
            "Drawer.Close.State",
            "Drawer.Content.Props",
            "Drawer.Content.State",
            "Drawer.Description.Props",
            "Drawer.Description.State",
            "Drawer.Indent.Props",
            "Drawer.Indent.State",
            "Drawer.IndentBackground.Props",
            "Drawer.IndentBackground.State",
            "Drawer.Popup.Props",
            "Drawer.Popup.State",
            "Drawer.Portal.Props",
            "Drawer.Portal.State",
            "Drawer.Provider.Props",
            "Drawer.Provider.State",
            "Drawer.Root.Actions",
            "Drawer.Root.ChangeEventDetails",
            "Drawer.Root.ChangeEventReason",
            "Drawer.Root.Props",
            "Drawer.Root.SnapPoint",
            "Drawer.Root.SnapPointChangeEventDetails",
            "Drawer.Root.SnapPointChangeEventReason",
            "Drawer.Root.State",
            "Drawer.SwipeArea.Props",
            "Drawer.SwipeArea.State",
            "Drawer.Title.Props",
            "Drawer.Title.State",
            "Drawer.Trigger.Props",
            "Drawer.Trigger.State",
            "Drawer.Viewport.Props",
            "Drawer.Viewport.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "state": {
                  "title": "State"
                },
                "position": {
                  "title": "Position"
                },
                "nested-drawers": {
                  "title": "Nested drawers"
                },
                "snap-points": {
                  "title": "Snap points"
                },
                "indent-effect": {
                  "title": "Indent effect"
                },
                "non-modal": {
                  "title": "Non-modal"
                },
                "mobile-navigation": {
                  "title": "Mobile navigation"
                },
                "swipe-to-open": {
                  "title": "Swipe to open"
                },
                "action-sheet-with-separate-destructive-action": {
                  "title": "Action sheet with separate destructive action"
                },
                "detached-triggers": {
                  "title": "Detached triggers"
                },
                "stacking-and-animations": {
                  "title": "Stacking and animations"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "provider": {
                  "title": "Provider"
                },
                "indentbackground": {
                  "title": "IndentBackground"
                },
                "indent": {
                  "title": "Indent"
                },
                "root": {
                  "title": "Root"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "swipearea": {
                  "title": "SwipeArea"
                },
                "portal": {
                  "title": "Portal"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "viewport": {
                  "title": "Viewport"
                },
                "popup": {
                  "title": "Popup"
                },
                "content": {
                  "title": "Content"
                },
                "title": {
                  "title": "Title"
                },
                "description": {
                  "title": "Description"
                },
                "close": {
                  "title": "Close"
                }
              }
            },
            "createhandle": {
              "title": "createHandle",
              "children": {
                "handle": {
                  "title": "Handle"
                }
              }
            }
          }
        },
        {
          "slug": "field",
          "path": "./field/page.mdx",
          "title": "Field",
          "description": "A component that provides labeling and validation for form controls.",
          "keywords": [
            "React Field Component",
            "Form Field Labeling",
            "Form Label",
            "Input Wrapper",
            "Form Validation",
            "Accessible Form Field",
            "Field Validation UI",
            "Headless React Components",
            "Custom Form Control Wrapper",
            "Form Description Error State",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "className",
                "dirty",
                "disabled",
                "invalid",
                "name",
                "render",
                "style",
                "touched",
                "validate",
                "validationDebounceTime",
                "validationMode"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-touched",
                "data-valid"
              ]
            },
            "Item": {
              "props": [
                "className",
                "disabled",
                "render",
                "style"
              ]
            },
            "Description": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-touched",
                "data-valid"
              ]
            },
            "Control": {
              "props": [
                "className",
                "defaultValue",
                "onValueChange",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-touched",
                "data-valid"
              ]
            },
            "Label": {
              "props": [
                "className",
                "nativeLabel",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-touched",
                "data-valid"
              ]
            },
            "Error": {
              "props": [
                "className",
                "match",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-ending-style",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-starting-style",
                "data-touched",
                "data-valid"
              ]
            },
            "Validity": {
              "props": [
                "children"
              ]
            }
          },
          "types": [
            "Field.Control.ChangeEventDetails",
            "Field.Control.ChangeEventReason",
            "Field.Control.Props",
            "Field.Control.State",
            "Field.Description.Props",
            "Field.Description.State",
            "Field.Error.Props",
            "Field.Error.State",
            "Field.Item.Props",
            "Field.Item.State",
            "Field.Label.Props",
            "Field.Label.State",
            "Field.Root.Actions",
            "Field.Root.Props",
            "Field.Root.State",
            "Field.Validity.Props",
            "Field.Validity.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "label": {
                  "title": "Label"
                },
                "control": {
                  "title": "Control"
                },
                "description": {
                  "title": "Description"
                },
                "item": {
                  "title": "Item"
                },
                "error": {
                  "title": "Error"
                },
                "validity": {
                  "title": "Validity"
                }
              }
            }
          }
        },
        {
          "slug": "fieldset",
          "path": "./fieldset/page.mdx",
          "title": "Fieldset",
          "description": "A native fieldset element with an easily stylable legend.",
          "keywords": [
            "React Fieldset",
            "Fieldset Component",
            "Form Field Grouping",
            "Form Fieldset",
            "Form Group",
            "Input Grouping",
            "Custom Legend Styling",
            "Fieldset Legend",
            "Accessible Fieldset",
            "Headless React Components",
            "Form Section Labeling",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Legend": {
              "props": [
                "className",
                "render",
                "style"
              ]
            }
          },
          "types": [
            "Fieldset.Legend.Props",
            "Fieldset.Legend.State",
            "Fieldset.Root.Props",
            "Fieldset.Root.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "legend": {
                  "title": "Legend"
                }
              }
            }
          }
        },
        {
          "slug": "form",
          "path": "./form/page.mdx",
          "title": "Form",
          "description": "A native form element with consolidated error handling.",
          "keywords": [
            "React Form Component",
            "Form Submission Handler",
            "Form Validation",
            "Form State",
            "Server Function Form",
            "JavaScript Form Values",
            "Accessible Form",
            "Headless React Components",
            "Form Error Handling",
            "Base UI"
          ],
          "exports": {
            "Form": {
              "props": [
                "actionsRef",
                "className",
                "errors",
                "onFormSubmit",
                "render",
                "style",
                "validationMode"
              ]
            }
          },
          "types": [
            "Form.Actions",
            "Form.Props",
            "Form.State",
            "Form.SubmitEventDetails",
            "Form.SubmitEventReason",
            "Form.ValidationMode",
            "Form.Values"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "submit-with-a-server-function": {
                  "title": "Submit with a Server Function"
                },
                "submit-form-values-as-a-javascript-object": {
                  "title": "Submit form values as a JavaScript object"
                },
                "using-with-zod": {
                  "title": "Using with Zod"
                }
              }
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        },
        {
          "slug": "input",
          "path": "./input/page.mdx",
          "title": "Input",
          "description": "A native input element that automatically works with [Field](/react/components/field).",
          "keywords": [
            "React Input",
            "Input Component",
            "Input Field",
            "Form Input Field",
            "Text Field",
            "Text Input",
            "Text Box",
            "Form Input",
            "Textarea Alternative",
            "Controlled Input",
            "Form Element",
            "Accessible Input",
            "Headless React Components",
            "Unstyled Input",
            "Base UI"
          ],
          "exports": {
            "Input": {
              "props": [
                "className",
                "defaultValue",
                "onValueChange",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-touched",
                "data-valid"
              ]
            }
          },
          "types": [
            "Input.ChangeEventDetails",
            "Input.ChangeEventReason",
            "Input.Props",
            "Input.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        },
        {
          "slug": "menu",
          "path": "./menu/page.mdx",
          "title": "Menu",
          "description": "A list of actions in a dropdown, enhanced with keyboard navigation.",
          "keywords": [
            "React Menu",
            "Menu Component",
            "Dropdown Menu",
            "Dropdown Actions",
            "Command Menu",
            "Action List",
            "Keyboard Navigation Menu",
            "Roving Tabindex Menu",
            "Nested Menu React",
            "Flyout Menu",
            "Context Actions",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "children",
                "closeParentOnEsc",
                "defaultOpen",
                "defaultTriggerId",
                "disabled",
                "handle",
                "highlightItemOnHover",
                "loopFocus",
                "modal",
                "onOpenChange",
                "onOpenChangeComplete",
                "open",
                "orientation",
                "triggerId"
              ]
            },
            "Trigger": {
              "props": [
                "children",
                "className",
                "closeDelay",
                "delay",
                "disabled",
                "handle",
                "nativeButton",
                "openOnHover",
                "payload",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-popup-open",
                "data-pressed"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-closed",
                "data-open",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--transform-origin"
              ]
            },
            "Popup": {
              "props": [
                "children",
                "className",
                "finalFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-ending-style",
                "data-instant",
                "data-open",
                "data-side",
                "data-starting-style"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-open",
                "data-side",
                "data-uncentered"
              ]
            },
            "Item": {
              "props": [
                "className",
                "closeOnClick",
                "disabled",
                "label",
                "nativeButton",
                "onClick",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-highlighted"
              ]
            },
            "Viewport": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-current",
                "data-instant",
                "data-previous",
                "data-transitioning"
              ],
              "cssVariables": [
                "--popup-height",
                "--popup-width"
              ]
            },
            "Group": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ]
            },
            "GroupLabel": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Separator": {
              "props": [
                "className",
                "orientation",
                "render",
                "style"
              ]
            },
            "SubmenuRoot": {
              "props": [
                "actionsRef",
                "children",
                "closeParentOnEsc",
                "defaultOpen",
                "defaultTriggerId",
                "disabled",
                "handle",
                "highlightItemOnHover",
                "loopFocus",
                "onOpenChange",
                "onOpenChangeComplete",
                "open",
                "orientation",
                "triggerId"
              ]
            },
            "SubmenuTrigger": {
              "props": [
                "className",
                "closeDelay",
                "delay",
                "disabled",
                "label",
                "nativeButton",
                "onClick",
                "openOnHover",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-highlighted",
                "data-popup-open"
              ]
            },
            "RadioGroup": {
              "props": [
                "children",
                "className",
                "defaultValue",
                "disabled",
                "onValueChange",
                "render",
                "style",
                "value"
              ]
            },
            "RadioItem": {
              "props": [
                "className",
                "closeOnClick",
                "disabled",
                "label",
                "nativeButton",
                "onClick",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-checked",
                "data-disabled",
                "data-highlighted",
                "data-unchecked"
              ]
            },
            "RadioItemIndicator": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-checked",
                "data-disabled",
                "data-ending-style",
                "data-starting-style",
                "data-unchecked"
              ]
            },
            "CheckboxItem": {
              "props": [
                "checked",
                "className",
                "closeOnClick",
                "defaultChecked",
                "disabled",
                "label",
                "nativeButton",
                "onCheckedChange",
                "onClick",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-checked",
                "data-disabled",
                "data-highlighted",
                "data-unchecked"
              ]
            },
            "CheckboxItemIndicator": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-checked",
                "data-disabled",
                "data-ending-style",
                "data-starting-style",
                "data-unchecked"
              ]
            },
            "createHandle": {},
            "Handle": {},
            "LinkItem": {
              "props": [
                "className",
                "closeOnClick",
                "label",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-highlighted"
              ]
            }
          },
          "types": [
            "Menu.Arrow.Props",
            "Menu.Arrow.State",
            "Menu.Backdrop.Props",
            "Menu.Backdrop.State",
            "Menu.CheckboxItem.ChangeEventDetails",
            "Menu.CheckboxItem.ChangeEventReason",
            "Menu.CheckboxItem.Props",
            "Menu.CheckboxItem.State",
            "Menu.CheckboxItemIndicator.Props",
            "Menu.CheckboxItemIndicator.State",
            "Menu.Group.Props",
            "Menu.Group.State",
            "Menu.GroupLabel.Props",
            "Menu.GroupLabel.State",
            "Menu.Item.Props",
            "Menu.Item.State",
            "Menu.LinkItem.Props",
            "Menu.LinkItem.State",
            "Menu.Popup.Props",
            "Menu.Popup.State",
            "Menu.Portal.Props",
            "Menu.Portal.State",
            "Menu.Positioner.Props",
            "Menu.Positioner.State",
            "Menu.RadioGroup.ChangeEventDetails",
            "Menu.RadioGroup.ChangeEventReason",
            "Menu.RadioGroup.Props",
            "Menu.RadioGroup.State",
            "Menu.RadioItem.Props",
            "Menu.RadioItem.State",
            "Menu.RadioItemIndicator.Props",
            "Menu.RadioItemIndicator.State",
            "Menu.Root.Actions",
            "Menu.Root.ChangeEventDetails",
            "Menu.Root.ChangeEventReason",
            "Menu.Root.Orientation",
            "Menu.Root.Props",
            "Menu.Root.State",
            "Menu.Separator.Props",
            "Menu.Separator.State",
            "Menu.SubmenuRoot.ChangeEventDetails",
            "Menu.SubmenuRoot.ChangeEventReason",
            "Menu.SubmenuRoot.Props",
            "Menu.SubmenuRoot.State",
            "Menu.SubmenuTrigger.Props",
            "Menu.SubmenuTrigger.State",
            "Menu.Trigger.Props",
            "Menu.Trigger.State",
            "Menu.Viewport.Props",
            "Menu.Viewport.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "open-on-hover": {
                  "title": "Open on hover"
                },
                "checkbox-items": {
                  "title": "Checkbox items"
                },
                "radio-items": {
                  "title": "Radio items"
                },
                "close-on-click": {
                  "title": "Close on click"
                },
                "group-labels": {
                  "title": "Group labels"
                },
                "nested-menu": {
                  "title": "Nested menu"
                },
                "navigate-to-another-page": {
                  "title": "Navigate to another page"
                },
                "open-a-dialog": {
                  "title": "Open a dialog"
                },
                "detached-triggers": {
                  "title": "Detached triggers"
                },
                "multiple-triggers": {
                  "title": "Multiple triggers"
                },
                "controlled-mode-with-multiple-triggers": {
                  "title": "Controlled mode with multiple triggers"
                },
                "animating-the-menu": {
                  "title": "Animating the Menu",
                  "children": {
                    "position-and-size": {
                      "title": "Position and Size"
                    },
                    "content": {
                      "title": "Content"
                    }
                  }
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "portal": {
                  "title": "Portal"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "popup": {
                  "title": "Popup"
                },
                "viewport": {
                  "title": "Viewport"
                },
                "arrow": {
                  "title": "Arrow"
                },
                "item": {
                  "title": "Item"
                },
                "linkitem": {
                  "title": "LinkItem"
                },
                "submenuroot": {
                  "title": "SubmenuRoot"
                },
                "submenutrigger": {
                  "title": "SubmenuTrigger"
                },
                "group": {
                  "title": "Group"
                },
                "grouplabel": {
                  "title": "GroupLabel"
                },
                "radiogroup": {
                  "title": "RadioGroup"
                },
                "radioitem": {
                  "title": "RadioItem"
                },
                "radioitemindicator": {
                  "title": "RadioItemIndicator"
                },
                "checkboxitem": {
                  "title": "CheckboxItem"
                },
                "checkboxitemindicator": {
                  "title": "CheckboxItemIndicator"
                },
                "separator": {
                  "title": "Separator"
                }
              }
            },
            "createhandle": {
              "title": "createHandle",
              "children": {
                "handle": {
                  "title": "Handle"
                }
              }
            }
          }
        },
        {
          "slug": "menubar",
          "path": "./menubar/page.mdx",
          "title": "Menubar",
          "description": "A menu bar providing commands and options for your application.",
          "keywords": [
            "React Menubar",
            "Menubar Component",
            "Application Menu Bar",
            "App Menu",
            "Navigation Bar",
            "Command Bar",
            "Desktop Style Menu",
            "Keyboard Navigation Menu",
            "Accessible Menubar",
            "Headless React Components",
            "Base UI"
          ],
          "exports": {
            "Menubar": {
              "props": [
                "className",
                "disabled",
                "loopFocus",
                "modal",
                "orientation",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-has-submenu-open",
                "data-modal",
                "data-orientation"
              ]
            }
          },
          "types": [
            "Menubar.Props",
            "Menubar.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        },
        {
          "slug": "meter",
          "path": "./meter/page.mdx",
          "title": "Meter",
          "description": "A graphical display of a numeric value within a range.",
          "keywords": [
            "React Meter",
            "Meter Component",
            "Progress Meter",
            "Gauge",
            "Level Indicator",
            "Measurement Display",
            "Capacity Indicator",
            "Value Indicator",
            "Rating Meter",
            "Fuel Gauge",
            "Accessible Meter",
            "Headless React Components",
            "Graphical Value Display",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "aria-valuetext",
                "className",
                "format",
                "getAriaValueText",
                "locale",
                "max",
                "min",
                "render",
                "style",
                "value"
              ]
            },
            "Value": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ]
            },
            "Indicator": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Track": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Label": {
              "props": [
                "className",
                "render",
                "style"
              ]
            }
          },
          "types": [
            "Meter.Indicator.Props",
            "Meter.Indicator.State",
            "Meter.Label.Props",
            "Meter.Label.State",
            "Meter.Root.Props",
            "Meter.Root.State",
            "Meter.Track.Props",
            "Meter.Track.State",
            "Meter.Value.Props",
            "Meter.Value.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "track": {
                  "title": "Track"
                },
                "indicator": {
                  "title": "Indicator"
                },
                "value": {
                  "title": "Value"
                },
                "label": {
                  "title": "Label"
                }
              }
            }
          }
        },
        {
          "slug": "navigation-menu",
          "path": "./navigation-menu/page.mdx",
          "title": "Navigation Menu",
          "description": "A collection of links and menus for website navigation.",
          "keywords": [
            "React Navigation Menu",
            "Navigation Menu Component",
            "Mega Menu React",
            "Dropdown Nav",
            "Flyout Menu",
            "Site Navigation",
            "Navbar",
            "Header Menu",
            "Multi Level Navigation",
            "Custom Link Menu",
            "Scrollable Navigation Menu",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "className",
                "closeDelay",
                "defaultValue",
                "delay",
                "onOpenChangeComplete",
                "onValueChange",
                "orientation",
                "render",
                "style",
                "value"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-popup-open",
                "data-pressed"
              ]
            },
            "Icon": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "List": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-closed",
                "data-instant",
                "data-open",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--positioner-height",
                "--positioner-width",
                "--transform-origin"
              ]
            },
            "Popup": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-side",
                "data-starting-style"
              ],
              "cssVariables": [
                "--popup-height",
                "--popup-width"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-open",
                "data-side",
                "data-uncentered"
              ]
            },
            "Item": {
              "props": [
                "className",
                "render",
                "style",
                "value"
              ]
            },
            "Content": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Viewport": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Link": {
              "props": [
                "active",
                "className",
                "closeOnClick",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-active"
              ]
            }
          },
          "types": [
            "NavigationMenu.Arrow.Props",
            "NavigationMenu.Arrow.State",
            "NavigationMenu.Backdrop.Props",
            "NavigationMenu.Backdrop.State",
            "NavigationMenu.Content.Props",
            "NavigationMenu.Content.State",
            "NavigationMenu.Icon.Props",
            "NavigationMenu.Icon.State",
            "NavigationMenu.Item.Props",
            "NavigationMenu.Item.State",
            "NavigationMenu.Link.Props",
            "NavigationMenu.Link.State",
            "NavigationMenu.List.Props",
            "NavigationMenu.List.State",
            "NavigationMenu.Popup.Props",
            "NavigationMenu.Popup.State",
            "NavigationMenu.Portal.Props",
            "NavigationMenu.Portal.State",
            "NavigationMenu.Positioner.Props",
            "NavigationMenu.Positioner.State",
            "NavigationMenu.Root.Actions",
            "NavigationMenu.Root.ChangeEventDetails",
            "NavigationMenu.Root.ChangeEventReason",
            "NavigationMenu.Root.Props",
            "NavigationMenu.Root.State",
            "NavigationMenu.Root.Value",
            "NavigationMenu.Trigger.Props",
            "NavigationMenu.Trigger.State",
            "NavigationMenu.Viewport.Props",
            "NavigationMenu.Viewport.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "nested-submenus": {
                  "title": "Nested submenus"
                },
                "nested-inline-submenus": {
                  "title": "Nested inline submenus"
                },
                "custom-links": {
                  "title": "Custom links"
                },
                "large-menus": {
                  "title": "Large menus"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "list": {
                  "title": "List"
                },
                "item": {
                  "title": "Item"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "icon": {
                  "title": "Icon"
                },
                "content": {
                  "title": "Content"
                },
                "link": {
                  "title": "Link"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "portal": {
                  "title": "Portal"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "popup": {
                  "title": "Popup"
                },
                "viewport": {
                  "title": "Viewport"
                },
                "arrow": {
                  "title": "Arrow"
                }
              }
            }
          }
        },
        {
          "slug": "number-field",
          "path": "./number-field/page.mdx",
          "title": "Number Field",
          "description": "A numeric input element with increment and decrement buttons, and a scrub area.",
          "keywords": [
            "React Number Field",
            "Number Input Component",
            "Number Spinner",
            "Spinner Input",
            "Spin Button",
            "Stepper",
            "Numeric Input",
            "Increment Decrement Buttons",
            "Up Down Control",
            "Scrub Area Input",
            "Numeric Form Control",
            "Accessible Number Field",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "allowOutOfRange",
                "allowWheelScrub",
                "className",
                "defaultValue",
                "disabled",
                "form",
                "format",
                "id",
                "inputRef",
                "largeStep",
                "locale",
                "max",
                "min",
                "name",
                "onValueChange",
                "onValueCommitted",
                "readOnly",
                "render",
                "required",
                "smallStep",
                "snapOnStep",
                "step",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-scrubbing",
                "data-touched",
                "data-valid"
              ]
            },
            "Input": {
              "props": [
                "aria-roledescription",
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-scrubbing",
                "data-touched",
                "data-valid"
              ]
            },
            "Group": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-scrubbing",
                "data-touched",
                "data-valid"
              ]
            },
            "ScrubArea": {
              "props": [
                "className",
                "direction",
                "pixelSensitivity",
                "render",
                "style",
                "teleportDistance"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-scrubbing",
                "data-touched",
                "data-valid"
              ]
            },
            "ScrubAreaCursor": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-scrubbing",
                "data-touched",
                "data-valid"
              ]
            },
            "Decrement": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-scrubbing",
                "data-touched",
                "data-valid"
              ]
            },
            "Increment": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-scrubbing",
                "data-touched",
                "data-valid"
              ]
            }
          },
          "types": [
            "NumberField.Decrement.Props",
            "NumberField.Decrement.State",
            "NumberField.Group.Props",
            "NumberField.Group.State",
            "NumberField.Increment.Props",
            "NumberField.Increment.State",
            "NumberField.Input.Props",
            "NumberField.Input.State",
            "NumberField.Root.ChangeEventDetails",
            "NumberField.Root.ChangeEventReason",
            "NumberField.Root.CommitEventDetails",
            "NumberField.Root.CommitEventReason",
            "NumberField.Root.Props",
            "NumberField.Root.State",
            "NumberField.ScrubArea.Props",
            "NumberField.ScrubArea.State",
            "NumberField.ScrubAreaCursor.Props",
            "NumberField.ScrubAreaCursor.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "scrubarea": {
                  "title": "ScrubArea"
                },
                "scrubareacursor": {
                  "title": "ScrubAreaCursor"
                },
                "group": {
                  "title": "Group"
                },
                "decrement": {
                  "title": "Decrement"
                },
                "input": {
                  "title": "Input"
                },
                "increment": {
                  "title": "Increment"
                }
              }
            }
          }
        },
        {
          "slug": "otp-field",
          "path": "./otp-field/page.mdx",
          "title": "OTP Field",
          "description": "A one-time password input composed of individual character slots.",
          "tags": [
            "Preview"
          ],
          "keywords": [
            "React OTP Field",
            "One-Time Password Input",
            "Verification Code Input",
            "OTP Input Component",
            "Pin Input",
            "Passcode Input",
            "Two-Factor Authentication Input",
            "2FA Input",
            "Multi-Slot Input",
            "Accessible OTP Field",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "autoComplete",
                "autoSubmit",
                "className",
                "defaultValue",
                "disabled",
                "form",
                "id",
                "inputMode",
                "length",
                "mask",
                "name",
                "onValueChange",
                "onValueComplete",
                "onValueInvalid",
                "readOnly",
                "render",
                "required",
                "sanitizeValue",
                "style",
                "validationType",
                "value"
              ],
              "dataAttributes": [
                "data-complete",
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-valid"
              ]
            },
            "Input": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-complete",
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-valid"
              ]
            },
            "Separator": {
              "props": [
                "className",
                "orientation",
                "render",
                "style"
              ]
            }
          },
          "types": [
            "OTPFieldPreview.Input.Props",
            "OTPFieldPreview.Input.State",
            "OTPFieldPreview.Root.ChangeEventDetails",
            "OTPFieldPreview.Root.ChangeEventReason",
            "OTPFieldPreview.Root.CompleteEventDetails",
            "OTPFieldPreview.Root.CompleteEventReason",
            "OTPFieldPreview.Root.InvalidEventDetails",
            "OTPFieldPreview.Root.InvalidEventReason",
            "OTPFieldPreview.Root.Props",
            "OTPFieldPreview.Root.State",
            "OTPFieldPreview.Root.ValidationType",
            "OTPFieldPreview.Separator.Props",
            "OTPFieldPreview.Separator.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "labeling-an-otp-field": {
                  "title": "Labeling an OTP field"
                },
                "form-integration": {
                  "title": "Form integration"
                },
                "alphanumeric-verification-codes": {
                  "title": "Alphanumeric verification codes"
                },
                "grouped-layouts": {
                  "title": "Grouped layouts"
                },
                "placeholder-hints": {
                  "title": "Placeholder hints"
                },
                "custom-sanitization": {
                  "title": "Custom sanitization"
                },
                "masked-entry": {
                  "title": "Masked entry"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "input": {
                  "title": "Input"
                },
                "separator": {
                  "title": "Separator"
                }
              }
            }
          }
        },
        {
          "slug": "popover",
          "path": "./popover/page.mdx",
          "title": "Popover",
          "description": "An accessible popup anchored to a button.",
          "keywords": [
            "React Popover",
            "Popover Component",
            "Popover Menu",
            "Popup Menu",
            "Anchored Popup",
            "Dropdown",
            "Overlay",
            "Floating Panel",
            "Tooltip Alternative",
            "Info Box",
            "Callout",
            "Popup Content",
            "Detached Trigger Popover",
            "Multi Trigger Popover",
            "Hover Trigger Popover",
            "Click Trigger Popover",
            "Focus Trigger Popover",
            "Animated Popover",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "children",
                "defaultOpen",
                "defaultTriggerId",
                "handle",
                "modal",
                "onOpenChange",
                "onOpenChangeComplete",
                "open",
                "triggerId"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "closeDelay",
                "delay",
                "handle",
                "id",
                "nativeButton",
                "openOnHover",
                "payload",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-popup-open",
                "data-pressed"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-closed",
                "data-open",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--positioner-height",
                "--positioner-width",
                "--transform-origin"
              ]
            },
            "Popup": {
              "props": [
                "className",
                "finalFocus",
                "initialFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-ending-style",
                "data-instant",
                "data-open",
                "data-side",
                "data-starting-style"
              ],
              "cssVariables": [
                "--popup-height",
                "--popup-width"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-open",
                "data-side",
                "data-uncentered"
              ]
            },
            "Title": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Description": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Close": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ]
            },
            "Viewport": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-current",
                "data-instant",
                "data-previous",
                "data-transitioning"
              ],
              "cssVariables": [
                "--popup-height",
                "--popup-width"
              ]
            },
            "createHandle": {},
            "Handle": {}
          },
          "types": [
            "Popover.Arrow.Props",
            "Popover.Arrow.State",
            "Popover.Backdrop.Props",
            "Popover.Backdrop.State",
            "Popover.Close.Props",
            "Popover.Close.State",
            "Popover.Description.Props",
            "Popover.Description.State",
            "Popover.Popup.Props",
            "Popover.Popup.State",
            "Popover.Portal.Props",
            "Popover.Portal.State",
            "Popover.Positioner.Props",
            "Popover.Positioner.State",
            "Popover.Root.Actions",
            "Popover.Root.ChangeEventDetails",
            "Popover.Root.ChangeEventReason",
            "Popover.Root.Props",
            "Popover.Root.State",
            "Popover.Title.Props",
            "Popover.Title.State",
            "Popover.Trigger.Props",
            "Popover.Trigger.State",
            "Popover.Viewport.Props",
            "Popover.Viewport.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "opening-on-hover": {
                  "title": "Opening on hover"
                },
                "detached-triggers": {
                  "title": "Detached triggers"
                },
                "multiple-triggers": {
                  "title": "Multiple triggers"
                },
                "controlled-mode-with-multiple-triggers": {
                  "title": "Controlled mode with multiple triggers"
                },
                "animating-the-popover": {
                  "title": "Animating the Popover",
                  "children": {
                    "position-and-size": {
                      "title": "Position and Size"
                    },
                    "content": {
                      "title": "Content"
                    }
                  }
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "portal": {
                  "title": "Portal"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "popup": {
                  "title": "Popup"
                },
                "arrow": {
                  "title": "Arrow"
                },
                "title": {
                  "title": "Title"
                },
                "description": {
                  "title": "Description"
                },
                "close": {
                  "title": "Close"
                },
                "viewport": {
                  "title": "Viewport"
                }
              }
            },
            "createhandle": {
              "title": "createHandle",
              "children": {
                "handle": {
                  "title": "Handle"
                }
              }
            }
          }
        },
        {
          "slug": "preview-card",
          "path": "./preview-card/page.mdx",
          "title": "Preview Card",
          "description": "A popup that appears when a link is hovered, showing a preview for sighted users.",
          "keywords": [
            "React Preview Card",
            "Preview Card Component",
            "Link Hover Preview",
            "Hover Card React",
            "Hover Card",
            "Link Tooltip",
            "URL Preview",
            "Link Preview Popup",
            "Content Preview",
            "Accessible Preview Popup",
            "Detached Trigger Preview Card",
            "Multiple Preview Card Triggers",
            "Animated Preview Card",
            "Headless React Components",
            "Link Preview UI",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "children",
                "defaultOpen",
                "defaultTriggerId",
                "handle",
                "onOpenChange",
                "onOpenChangeComplete",
                "open",
                "triggerId"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "closeDelay",
                "delay",
                "handle",
                "payload",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-popup-open"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-closed",
                "data-open",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--transform-origin"
              ]
            },
            "Popup": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-side",
                "data-starting-style"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-open",
                "data-side",
                "data-uncentered"
              ]
            },
            "Viewport": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-current",
                "data-instant",
                "data-previous",
                "data-transitioning"
              ],
              "cssVariables": [
                "--popup-height",
                "--popup-width"
              ]
            },
            "createHandle": {},
            "Handle": {}
          },
          "types": [
            "PreviewCard.Arrow.Props",
            "PreviewCard.Arrow.State",
            "PreviewCard.Backdrop.Props",
            "PreviewCard.Backdrop.State",
            "PreviewCard.Popup.Props",
            "PreviewCard.Popup.State",
            "PreviewCard.Portal.Props",
            "PreviewCard.Portal.State",
            "PreviewCard.Positioner.Props",
            "PreviewCard.Positioner.State",
            "PreviewCard.Root.Actions",
            "PreviewCard.Root.ChangeEventDetails",
            "PreviewCard.Root.ChangeEventReason",
            "PreviewCard.Root.Props",
            "PreviewCard.Root.State",
            "PreviewCard.Trigger.Props",
            "PreviewCard.Trigger.State",
            "PreviewCard.Viewport.Props",
            "PreviewCard.Viewport.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "detached-triggers": {
                  "title": "Detached triggers"
                },
                "multiple-triggers": {
                  "title": "Multiple triggers"
                },
                "controlled-mode-with-multiple-triggers": {
                  "title": "Controlled mode with multiple triggers"
                },
                "animating-the-preview-card": {
                  "title": "Animating the Preview Card",
                  "children": {
                    "position-and-size": {
                      "title": "Position and Size"
                    },
                    "content": {
                      "title": "Content"
                    }
                  }
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "portal": {
                  "title": "Portal"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "popup": {
                  "title": "Popup"
                },
                "viewport": {
                  "title": "Viewport"
                },
                "arrow": {
                  "title": "Arrow"
                }
              }
            },
            "createhandle": {
              "title": "createHandle",
              "children": {
                "handle": {
                  "title": "Handle"
                }
              }
            }
          }
        },
        {
          "slug": "progress",
          "path": "./progress/page.mdx",
          "title": "Progress",
          "description": "Displays the status of a task that takes a long time.",
          "keywords": [
            "React Progress Bar",
            "Progress Component",
            "Progress Indicator",
            "Loader",
            "Loading Bar",
            "Upload Progress",
            "Download Progress",
            "Task Status Indicator",
            "Determinate Progress",
            "Indeterminate Progress",
            "Accessible Progress",
            "Headless React Components",
            "Loading Indicator",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "aria-valuetext",
                "className",
                "format",
                "getAriaValueText",
                "locale",
                "max",
                "min",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-complete",
                "data-indeterminate",
                "data-progressing"
              ]
            },
            "Value": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-complete",
                "data-indeterminate",
                "data-progressing"
              ]
            },
            "Indicator": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-complete",
                "data-indeterminate",
                "data-progressing"
              ]
            },
            "Track": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-complete",
                "data-indeterminate",
                "data-progressing"
              ]
            },
            "Label": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-complete",
                "data-indeterminate",
                "data-progressing"
              ]
            }
          },
          "types": [
            "Progress.Indicator.Props",
            "Progress.Indicator.State",
            "Progress.Label.Props",
            "Progress.Label.State",
            "Progress.Root.Props",
            "Progress.Root.State",
            "Progress.Track.Props",
            "Progress.Track.State",
            "Progress.Value.Props",
            "Progress.Value.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "track": {
                  "title": "Track"
                },
                "indicator": {
                  "title": "Indicator"
                },
                "value": {
                  "title": "Value"
                },
                "label": {
                  "title": "Label"
                }
              }
            }
          }
        },
        {
          "slug": "radio",
          "path": "./radio/page.mdx",
          "title": "Radio",
          "description": "An easily stylable radio button component.",
          "keywords": [
            "React Radio Button",
            "Radio Group Component",
            "Radio Button",
            "Radio Input",
            "Single Choice",
            "Exclusive Choice",
            "Mutually Exclusive",
            "Option Selector",
            "Option Button",
            "Form Radio Control",
            "Accessible Radio Group",
            "Customizable Radio",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "disabled",
                "inputRef",
                "nativeButton",
                "readOnly",
                "render",
                "required",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-checked",
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-unchecked",
                "data-valid"
              ]
            },
            "Indicator": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-checked",
                "data-dirty",
                "data-disabled",
                "data-ending-style",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-starting-style",
                "data-touched",
                "data-unchecked",
                "data-valid"
              ]
            }
          },
          "types": [
            "Radio.Indicator.Props",
            "Radio.Indicator.State",
            "Radio.Root.Props",
            "Radio.Root.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "labeling-a-radio-group": {
                  "title": "Labeling a radio group"
                },
                "rendering-as-a-native-button": {
                  "title": "Rendering as a native button"
                },
                "form-integration": {
                  "title": "Form integration"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "radiogroup": {
                  "title": "RadioGroup"
                },
                "root": {
                  "title": "Root"
                },
                "indicator": {
                  "title": "Indicator"
                }
              }
            }
          }
        },
        {
          "slug": "scroll-area",
          "path": "./scroll-area/page.mdx",
          "title": "Scroll Area",
          "description": "A native scroll container with custom scrollbars.",
          "keywords": [
            "React Scroll Area",
            "Custom Scrollbars",
            "Custom Scroll",
            "Scrollbar",
            "Styled Scrollbar",
            "Virtual Scroll",
            "Scroll Area Component",
            "Overflow Container",
            "Scrollable Region",
            "Scrollable Content",
            "Overflow Scroll",
            "Gradient Scroll Fade",
            "Scrollable Container",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "overflowEdgeThreshold",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-has-overflow-x",
                "data-has-overflow-y",
                "data-overflow-x-end",
                "data-overflow-x-start",
                "data-overflow-y-end",
                "data-overflow-y-start",
                "data-scrolling"
              ],
              "cssVariables": [
                "--scroll-area-corner-height",
                "--scroll-area-corner-width"
              ]
            },
            "Content": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Viewport": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-has-overflow-x",
                "data-has-overflow-y",
                "data-overflow-x-end",
                "data-overflow-x-start",
                "data-overflow-y-end",
                "data-overflow-y-start",
                "data-scrolling"
              ],
              "cssVariables": [
                "--scroll-area-overflow-x-end",
                "--scroll-area-overflow-x-start",
                "--scroll-area-overflow-y-end",
                "--scroll-area-overflow-y-start"
              ]
            },
            "Thumb": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-orientation"
              ]
            },
            "Scrollbar": {
              "props": [
                "className",
                "keepMounted",
                "orientation",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-has-overflow-x",
                "data-has-overflow-y",
                "data-hovering",
                "data-orientation",
                "data-overflow-x-end",
                "data-overflow-x-start",
                "data-overflow-y-end",
                "data-overflow-y-start",
                "data-scrolling"
              ],
              "cssVariables": [
                "--scroll-area-thumb-height",
                "--scroll-area-thumb-width"
              ]
            },
            "Corner": {
              "props": [
                "className",
                "render",
                "style"
              ]
            }
          },
          "types": [
            "ScrollArea.Content.Props",
            "ScrollArea.Content.State",
            "ScrollArea.Corner.Props",
            "ScrollArea.Corner.State",
            "ScrollArea.Root.Props",
            "ScrollArea.Root.State",
            "ScrollArea.Scrollbar.Props",
            "ScrollArea.Scrollbar.State",
            "ScrollArea.Thumb.Props",
            "ScrollArea.Thumb.State",
            "ScrollArea.Viewport.Props",
            "ScrollArea.Viewport.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "both-scrollbars": {
                  "title": "Both scrollbars"
                },
                "gradient-scroll-fade": {
                  "title": "Gradient scroll fade"
                },
                "combining-with-tabs": {
                  "title": "Combining with Tabs"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "viewport": {
                  "title": "Viewport"
                },
                "content": {
                  "title": "Content"
                },
                "scrollbar": {
                  "title": "Scrollbar"
                },
                "thumb": {
                  "title": "Thumb"
                },
                "corner": {
                  "title": "Corner"
                }
              }
            }
          }
        },
        {
          "slug": "select",
          "path": "./select/page.mdx",
          "title": "Select",
          "description": "A common form component for choosing a predefined value in a dropdown menu.",
          "keywords": [
            "React Select Component",
            "Dropdown Select",
            "Select Box",
            "Select Menu",
            "Picker",
            "Listbox",
            "Choice Selector",
            "Option List",
            "Dropdown Menu",
            "Combo Box",
            "Multi Select React",
            "Multiselect",
            "Object Value Select",
            "Single Select",
            "Keyboard Navigation Select",
            "Listbox Role",
            "Accessible Select",
            "Align Item with Trigger",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "autoComplete",
                "children",
                "defaultOpen",
                "defaultValue",
                "disabled",
                "form",
                "highlightItemOnHover",
                "id",
                "inputRef",
                "isItemEqualToValue",
                "itemToStringLabel",
                "itemToStringValue",
                "items",
                "modal",
                "multiple",
                "name",
                "onOpenChange",
                "onOpenChangeComplete",
                "onValueChange",
                "open",
                "readOnly",
                "required",
                "value"
              ]
            },
            "Trigger": {
              "props": [
                "children",
                "className",
                "disabled",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-placeholder",
                "data-popup-open",
                "data-popup-side",
                "data-pressed",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-valid"
              ]
            },
            "Value": {
              "props": [
                "children",
                "className",
                "placeholder",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-placeholder"
              ]
            },
            "Icon": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-popup-open"
              ]
            },
            "List": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "render",
                "style"
              ]
            },
            "Backdrop": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-starting-style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignItemWithTrigger",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-closed",
                "data-open",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--transform-origin"
              ]
            },
            "Popup": {
              "props": [
                "children",
                "className",
                "finalFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-ending-style",
                "data-open",
                "data-side",
                "data-starting-style"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-open",
                "data-side",
                "data-uncentered"
              ]
            },
            "Item": {
              "props": [
                "children",
                "className",
                "disabled",
                "label",
                "nativeButton",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-highlighted",
                "data-selected"
              ]
            },
            "Group": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "GroupLabel": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "Separator": {
              "props": [
                "className",
                "orientation",
                "render",
                "style"
              ]
            },
            "Label": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "ItemText": {
              "props": [
                "className",
                "render",
                "style"
              ]
            },
            "ItemIndicator": {
              "props": [
                "children",
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-ending-style",
                "data-starting-style"
              ]
            },
            "ScrollUpArrow": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-direction",
                "data-ending-style",
                "data-side",
                "data-starting-style",
                "data-visible"
              ]
            },
            "ScrollDownArrow": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-direction",
                "data-ending-style",
                "data-side",
                "data-starting-style",
                "data-visible"
              ]
            }
          },
          "types": [
            "Select.Arrow.Props",
            "Select.Arrow.State",
            "Select.Backdrop.Props",
            "Select.Backdrop.State",
            "Select.Group.Props",
            "Select.Group.State",
            "Select.GroupLabel.Props",
            "Select.GroupLabel.State",
            "Select.Icon.Props",
            "Select.Icon.State",
            "Select.Item.Props",
            "Select.Item.State",
            "Select.ItemIndicator.Props",
            "Select.ItemIndicator.State",
            "Select.ItemText.Props",
            "Select.ItemText.State",
            "Select.Label.Props",
            "Select.Label.State",
            "Select.List.Props",
            "Select.List.State",
            "Select.Popup.Props",
            "Select.Popup.State",
            "Select.Portal.Props",
            "Select.Portal.State",
            "Select.Positioner.Props",
            "Select.Positioner.State",
            "Select.Root.Actions",
            "Select.Root.ChangeEventDetails",
            "Select.Root.ChangeEventReason",
            "Select.Root.Props",
            "Select.Root.State",
            "Select.ScrollDownArrow.Props",
            "Select.ScrollDownArrow.State",
            "Select.ScrollUpArrow.Props",
            "Select.ScrollUpArrow.State",
            "Select.Separator.Props",
            "Select.Separator.State",
            "Select.Trigger.Props",
            "Select.Trigger.State",
            "Select.Value.Props",
            "Select.Value.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "positioning": {
              "title": "Positioning"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "typed-wrapper-component": {
                  "title": "Typed wrapper component"
                },
                "formatting-the-value": {
                  "title": "Formatting the value"
                },
                "labeling-a-select": {
                  "title": "Labeling a select"
                },
                "placeholder-values": {
                  "title": "Placeholder values"
                },
                "multiple-selection": {
                  "title": "Multiple selection"
                },
                "object-values": {
                  "title": "Object values"
                },
                "grouped": {
                  "title": "Grouped"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "label": {
                  "title": "Label"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "value": {
                  "title": "Value"
                },
                "icon": {
                  "title": "Icon"
                },
                "backdrop": {
                  "title": "Backdrop"
                },
                "portal": {
                  "title": "Portal"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "popup": {
                  "title": "Popup"
                },
                "list": {
                  "title": "List"
                },
                "arrow": {
                  "title": "Arrow"
                },
                "item": {
                  "title": "Item"
                },
                "itemtext": {
                  "title": "ItemText"
                },
                "itemindicator": {
                  "title": "ItemIndicator"
                },
                "group": {
                  "title": "Group"
                },
                "grouplabel": {
                  "title": "GroupLabel"
                },
                "scrolluparrow": {
                  "title": "ScrollUpArrow"
                },
                "scrolldownarrow": {
                  "title": "ScrollDownArrow"
                },
                "separator": {
                  "title": "Separator"
                }
              }
            }
          }
        },
        {
          "slug": "separator",
          "path": "./separator/page.mdx",
          "title": "Separator",
          "description": "A separator element accessible to screen readers.",
          "keywords": [
            "React Separator",
            "Divider Component",
            "Divider",
            "Horizontal Rule",
            "Horizontal Divider",
            "Vertical Divider",
            "Visual Separator",
            "Section Divider",
            "HR",
            "Accessible Separator",
            "Screen Reader Separator",
            "Headless React Components",
            "Base UI"
          ],
          "exports": {
            "Separator": {
              "props": [
                "className",
                "orientation",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-orientation"
              ]
            }
          },
          "types": [
            "Separator.Props",
            "Separator.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        },
        {
          "slug": "slider",
          "path": "./slider/page.mdx",
          "title": "Slider",
          "description": "An easily stylable range input.",
          "keywords": [
            "React Slider",
            "Range Slider Component",
            "Range Input",
            "Range Control",
            "Track Control",
            "Value Selector",
            "Keyboard Slider Control",
            "Dual Slider",
            "Double Slider",
            "Two-Handle Slider",
            "Multi Thumb Slider",
            "Thumb Alignment Edge",
            "Accessible Slider",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "defaultValue",
                "disabled",
                "form",
                "format",
                "largeStep",
                "locale",
                "max",
                "min",
                "minStepsBetweenValues",
                "name",
                "onValueChange",
                "onValueCommitted",
                "orientation",
                "render",
                "step",
                "style",
                "thumbAlignment",
                "thumbCollisionBehavior",
                "value"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-dragging",
                "data-focused",
                "data-invalid",
                "data-orientation",
                "data-touched",
                "data-valid"
              ]
            },
            "Value": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-dragging",
                "data-focused",
                "data-invalid",
                "data-orientation",
                "data-touched",
                "data-valid"
              ]
            },
            "Indicator": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-dragging",
                "data-focused",
                "data-invalid",
                "data-orientation",
                "data-touched",
                "data-valid"
              ]
            },
            "Track": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-dragging",
                "data-focused",
                "data-invalid",
                "data-orientation",
                "data-touched",
                "data-valid"
              ]
            },
            "Thumb": {
              "props": [
                "className",
                "disabled",
                "getAriaLabel",
                "getAriaValueText",
                "index",
                "inputRef",
                "onBlur",
                "onFocus",
                "render",
                "style",
                "tabIndex"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-dragging",
                "data-focused",
                "data-index",
                "data-invalid",
                "data-orientation",
                "data-touched",
                "data-valid"
              ]
            },
            "Control": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-dirty",
                "data-disabled",
                "data-dragging",
                "data-focused",
                "data-invalid",
                "data-orientation",
                "data-touched",
                "data-valid"
              ]
            },
            "Label": {
              "props": [
                "className",
                "render",
                "style"
              ]
            }
          },
          "types": [
            "Slider.Control.Props",
            "Slider.Control.State",
            "Slider.Indicator.Props",
            "Slider.Indicator.State",
            "Slider.Label.Props",
            "Slider.Label.State",
            "Slider.Root.ChangeEventDetails",
            "Slider.Root.ChangeEventReason",
            "Slider.Root.CommitEventDetails",
            "Slider.Root.CommitEventReason",
            "Slider.Root.Props",
            "Slider.Root.State",
            "Slider.Thumb.Props",
            "Slider.Thumb.State",
            "Slider.Track.Props",
            "Slider.Track.State",
            "Slider.Value.Props",
            "Slider.Value.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "range-slider": {
                  "title": "Range slider"
                },
                "thumb-alignment": {
                  "title": "Thumb alignment"
                },
                "labeling-a-slider": {
                  "title": "Labeling a slider"
                },
                "vertical": {
                  "title": "Vertical"
                },
                "form-integration": {
                  "title": "Form integration"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "label": {
                  "title": "Label"
                },
                "value": {
                  "title": "Value"
                },
                "control": {
                  "title": "Control"
                },
                "track": {
                  "title": "Track"
                },
                "indicator": {
                  "title": "Indicator"
                },
                "thumb": {
                  "title": "Thumb"
                }
              }
            }
          }
        },
        {
          "slug": "switch",
          "path": "./switch/page.mdx",
          "title": "Switch",
          "description": "A control that indicates whether a setting is on or off.",
          "keywords": [
            "React Switch",
            "Toggle Switch Component",
            "Toggle Switch",
            "Toggle Button",
            "On/Off Control",
            "On Off Switch",
            "Binary Switch",
            "Checkbox Alternative",
            "Form Toggle Control",
            "Aria Switch Role",
            "Accessible Switch",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "checked",
                "className",
                "defaultChecked",
                "disabled",
                "form",
                "id",
                "inputRef",
                "name",
                "nativeButton",
                "onCheckedChange",
                "readOnly",
                "render",
                "required",
                "style",
                "uncheckedValue",
                "value"
              ],
              "dataAttributes": [
                "data-checked",
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-unchecked",
                "data-valid"
              ]
            },
            "Thumb": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-checked",
                "data-dirty",
                "data-disabled",
                "data-filled",
                "data-focused",
                "data-invalid",
                "data-readonly",
                "data-required",
                "data-touched",
                "data-unchecked",
                "data-valid"
              ]
            }
          },
          "types": [
            "Switch.Root.ChangeEventDetails",
            "Switch.Root.ChangeEventReason",
            "Switch.Root.Props",
            "Switch.Root.State",
            "Switch.Thumb.Props",
            "Switch.Thumb.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "labeling-a-switch": {
                  "title": "Labeling a switch"
                },
                "rendering-as-a-native-button": {
                  "title": "Rendering as a native button"
                },
                "form-integration": {
                  "title": "Form integration"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "thumb": {
                  "title": "Thumb"
                }
              }
            }
          }
        },
        {
          "slug": "tabs",
          "path": "./tabs/page.mdx",
          "title": "Tabs",
          "description": "A component for toggling between related panels on the same page.",
          "keywords": [
            "React Tabs",
            "Tabbed Interface Component",
            "Tab Panel",
            "Tab Control",
            "Tabbed Navigation",
            "Tabbed UI",
            "Page Switcher",
            "Content Switcher",
            "View Switcher",
            "Tab List Indicator",
            "Tablist",
            "Tabpanel",
            "Keyboard Navigation Tabs",
            "Controlled Tabs",
            "Accessible Tabs",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "defaultValue",
                "keepMounted",
                "onValueChange",
                "orientation",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-orientation"
              ]
            },
            "List": {
              "props": [
                "activateOnFocus",
                "className",
                "loopFocus",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-orientation"
              ]
            },
            "Panel": {
              "props": [
                "className",
                "keepMounted",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-ending-style",
                "data-hidden",
                "data-index",
                "data-orientation",
                "data-starting-style"
              ]
            },
            "Indicator": {
              "props": [
                "className",
                "render",
                "renderBeforeHydration",
                "style"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-orientation"
              ],
              "cssVariables": [
                "--active-tab-bottom",
                "--active-tab-height",
                "--active-tab-left",
                "--active-tab-right",
                "--active-tab-top",
                "--active-tab-width"
              ]
            },
            "Tab": {
              "props": [
                "className",
                "disabled",
                "nativeButton",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-active",
                "data-disabled",
                "data-orientation"
              ]
            }
          },
          "types": [
            "Tabs.Indicator.Props",
            "Tabs.Indicator.State",
            "Tabs.List.Props",
            "Tabs.List.State",
            "Tabs.Panel.Metadata",
            "Tabs.Panel.Props",
            "Tabs.Panel.State",
            "Tabs.Root.ChangeEventDetails",
            "Tabs.Root.ChangeEventReason",
            "Tabs.Root.Orientation",
            "Tabs.Root.Props",
            "Tabs.Root.State",
            "Tabs.Tab.ActivationDirection",
            "Tabs.Tab.Metadata",
            "Tabs.Tab.Position",
            "Tabs.Tab.Props",
            "Tabs.Tab.Size",
            "Tabs.Tab.State",
            "Tabs.Tab.Value"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "links": {
                  "title": "Links"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "list": {
                  "title": "List"
                },
                "tab": {
                  "title": "Tab"
                },
                "indicator": {
                  "title": "Indicator"
                },
                "panel": {
                  "title": "Panel"
                }
              }
            }
          }
        },
        {
          "slug": "toast",
          "path": "./toast/page.mdx",
          "title": "Toast",
          "description": "Generates toast notifications.",
          "keywords": [
            "React Toast",
            "Toast Notification",
            "Toast Notifications",
            "Notification Component",
            "Notification",
            "Snackbar",
            "Message Notification",
            "Alert Notification",
            "Alert Message",
            "Flash Message",
            "Push Notification",
            "Temporary Message",
            "Dismissible Notification",
            "Toast Message",
            "Toast Manager",
            "Anchored Toast",
            "Swipe Dismiss Toast",
            "Status Message",
            "Timed Notification",
            "Stacked Toasts",
            "Live Region",
            "Accessible Toast",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "render",
                "style",
                "swipeDirection",
                "toast"
              ],
              "dataAttributes": [
                "data-ending-style",
                "data-expanded",
                "data-limited",
                "data-starting-style",
                "data-swipe-direction",
                "data-swiping",
                "data-type"
              ],
              "cssVariables": [
                "--toast-height",
                "--toast-index",
                "--toast-offset-y",
                "--toast-swipe-movement-x",
                "--toast-swipe-movement-y"
              ]
            },
            "Provider": {
              "props": [
                "children",
                "limit",
                "timeout",
                "toastManager"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "render",
                "style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style",
                "toast"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--transform-origin"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-side",
                "data-uncentered"
              ]
            },
            "Content": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-behind",
                "data-expanded"
              ]
            },
            "Title": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-type"
              ]
            },
            "Description": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-type"
              ]
            },
            "Close": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-type"
              ]
            },
            "Action": {
              "props": [
                "className",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-type"
              ]
            },
            "Viewport": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-expanded"
              ],
              "cssVariables": [
                "--toast-frontmost-height"
              ]
            },
            "createToastManager": {},
            "useToastManager": {}
          },
          "types": [
            "Toast.Action.Props",
            "Toast.Action.State",
            "Toast.Arrow.Props",
            "Toast.Arrow.State",
            "Toast.Close.Props",
            "Toast.Close.State",
            "Toast.Content.Props",
            "Toast.Content.State",
            "Toast.Description.Props",
            "Toast.Description.State",
            "Toast.Portal.Props",
            "Toast.Portal.State",
            "Toast.Positioner.Props",
            "Toast.Positioner.State",
            "Toast.Provider.Props",
            "Toast.Provider.State",
            "Toast.Root.Props",
            "Toast.Root.State",
            "Toast.Root.ToastObject",
            "Toast.Title.Props",
            "Toast.Title.State",
            "Toast.Viewport.Props",
            "Toast.Viewport.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "general-usage": {
              "title": "General usage"
            },
            "global-manager": {
              "title": "Global manager"
            },
            "stacking-and-animations": {
              "title": "Stacking and animations"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "anchored-toasts": {
                  "title": "Anchored toasts"
                },
                "custom-position": {
                  "title": "Custom position"
                },
                "undo-action": {
                  "title": "Undo action"
                },
                "promise": {
                  "title": "Promise"
                },
                "custom": {
                  "title": "Custom"
                },
                "deduplicated-toast": {
                  "title": "Deduplicated toast"
                },
                "varying-heights": {
                  "title": "Varying heights"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "provider": {
                  "title": "Provider"
                },
                "viewport": {
                  "title": "Viewport"
                },
                "portal": {
                  "title": "Portal"
                },
                "root": {
                  "title": "Root"
                },
                "content": {
                  "title": "Content"
                },
                "title": {
                  "title": "Title"
                },
                "description": {
                  "title": "Description"
                },
                "action": {
                  "title": "Action"
                },
                "close": {
                  "title": "Close"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "arrow": {
                  "title": "Arrow"
                }
              }
            },
            "usetoastmanager": {
              "title": "useToastManager",
              "children": {
                "add-method": {
                  "title": "add method"
                },
                "update-method": {
                  "title": "update method"
                },
                "close-method": {
                  "title": "close method"
                },
                "promise-method": {
                  "title": "promise method"
                }
              }
            },
            "additional-types": {
              "title": "Additional Types"
            }
          }
        },
        {
          "slug": "toggle",
          "path": "./toggle/page.mdx",
          "title": "Toggle",
          "description": "A two-state button that can be on or off.",
          "keywords": [
            "React Toggle",
            "Toggle Button Component",
            "Two State Button",
            "Press Button",
            "Push Toggle",
            "Pressed State Button",
            "Toggle Control",
            "ARIA Pressed Control",
            "Accessible Toggle",
            "Headless React Components",
            "Base UI"
          ],
          "exports": {
            "Toggle": {
              "props": [
                "className",
                "defaultPressed",
                "disabled",
                "nativeButton",
                "onPressedChange",
                "pressed",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-pressed"
              ]
            }
          },
          "types": [
            "Toggle.ChangeEventDetails",
            "Toggle.ChangeEventReason",
            "Toggle.Props",
            "Toggle.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        },
        {
          "slug": "toggle-group",
          "path": "./toggle-group/page.mdx",
          "title": "Toggle Group",
          "description": "Provides a shared state to a series of toggle buttons.",
          "keywords": [
            "React Toggle Group",
            "Toggle Button Group",
            "Segmented Control",
            "Button Set",
            "Radio Group Alternative",
            "Exclusive Selection Toggle",
            "Multi Select Toggle Buttons",
            "Accessible Toggle Group",
            "Headless React Components",
            "Base UI"
          ],
          "exports": {
            "ToggleGroup": {
              "props": [
                "className",
                "defaultValue",
                "disabled",
                "loopFocus",
                "multiple",
                "onValueChange",
                "orientation",
                "render",
                "style",
                "value"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-multiple",
                "data-orientation"
              ]
            }
          },
          "types": [
            "ToggleGroup.ChangeEventDetails",
            "ToggleGroup.ChangeEventReason",
            "ToggleGroup.Props",
            "ToggleGroup.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "multiple": {
                  "title": "Multiple"
                }
              }
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        },
        {
          "slug": "toolbar",
          "path": "./toolbar/page.mdx",
          "title": "Toolbar",
          "description": "A container for grouping a set of buttons and controls.",
          "keywords": [
            "React Toolbar",
            "Toolbar Button Group",
            "Action Bar",
            "Button Bar",
            "Command Strip",
            "Headless Toolbar Component",
            "Accessible Toolbar",
            "Popup Trigger Toolbar",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "className",
                "disabled",
                "loopFocus",
                "orientation",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-orientation"
              ]
            },
            "Input": {
              "props": [
                "className",
                "defaultValue",
                "disabled",
                "focusableWhenDisabled",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-focusable",
                "data-orientation"
              ]
            },
            "Group": {
              "props": [
                "className",
                "disabled",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-orientation"
              ]
            },
            "Separator": {
              "props": [
                "className",
                "orientation",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-orientation"
              ]
            },
            "Button": {
              "props": [
                "className",
                "disabled",
                "focusableWhenDisabled",
                "nativeButton",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-disabled",
                "data-focusable",
                "data-orientation"
              ]
            },
            "Link": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-orientation"
              ]
            }
          },
          "types": [
            "Toolbar.Button.Props",
            "Toolbar.Button.State",
            "Toolbar.Group.Props",
            "Toolbar.Group.State",
            "Toolbar.Input.Props",
            "Toolbar.Input.State",
            "Toolbar.Link.Props",
            "Toolbar.Link.State",
            "Toolbar.Root.ItemMetadata",
            "Toolbar.Root.Orientation",
            "Toolbar.Root.Props",
            "Toolbar.Root.State",
            "Toolbar.Separator.Props",
            "Toolbar.Separator.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "examples": {
              "title": "Examples",
              "children": {
                "using-with-menu": {
                  "title": "Using with Menu"
                },
                "using-with-tooltip": {
                  "title": "Using with Tooltip"
                },
                "using-with-numberfield": {
                  "title": "Using with NumberField"
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "root": {
                  "title": "Root"
                },
                "button": {
                  "title": "Button"
                },
                "link": {
                  "title": "Link"
                },
                "input": {
                  "title": "Input"
                },
                "group": {
                  "title": "Group"
                },
                "separator": {
                  "title": "Separator"
                }
              }
            }
          }
        },
        {
          "slug": "tooltip",
          "path": "./tooltip/page.mdx",
          "title": "Tooltip",
          "description": "A popup that appears when an element is hovered or focused, showing a hint for sighted users.",
          "keywords": [
            "React Tooltip",
            "Tooltip Component",
            "Detached Trigger Tooltip",
            "Hint",
            "Help Text",
            "Hover Text",
            "Hover Hint",
            "Info Popup",
            "Infotip",
            "Aria Describedby Tooltip",
            "Accessible Tooltip",
            "Multiple Tooltip Triggers",
            "Animated Tooltip",
            "Headless React Components",
            "Base UI"
          ],
          "parts": {
            "Root": {
              "props": [
                "actionsRef",
                "children",
                "defaultOpen",
                "defaultTriggerId",
                "disableHoverablePopup",
                "disabled",
                "handle",
                "onOpenChange",
                "onOpenChangeComplete",
                "open",
                "trackCursorAxis",
                "triggerId"
              ]
            },
            "Provider": {
              "props": [
                "children",
                "closeDelay",
                "delay",
                "timeout"
              ]
            },
            "Trigger": {
              "props": [
                "className",
                "closeDelay",
                "closeOnClick",
                "delay",
                "disabled",
                "handle",
                "payload",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-popup-open",
                "data-trigger-disabled"
              ]
            },
            "Portal": {
              "props": [
                "className",
                "container",
                "keepMounted",
                "render",
                "style"
              ]
            },
            "Positioner": {
              "props": [
                "align",
                "alignOffset",
                "anchor",
                "arrowPadding",
                "className",
                "collisionAvoidance",
                "collisionBoundary",
                "collisionPadding",
                "disableAnchorTracking",
                "positionMethod",
                "render",
                "side",
                "sideOffset",
                "sticky",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-anchor-hidden",
                "data-closed",
                "data-open",
                "data-side"
              ],
              "cssVariables": [
                "--anchor-height",
                "--anchor-width",
                "--available-height",
                "--available-width",
                "--transform-origin"
              ]
            },
            "Popup": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-ending-style",
                "data-instant",
                "data-open",
                "data-side",
                "data-starting-style"
              ]
            },
            "Arrow": {
              "props": [
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-align",
                "data-closed",
                "data-instant",
                "data-open",
                "data-side",
                "data-uncentered"
              ]
            },
            "Viewport": {
              "props": [
                "children",
                "className",
                "render",
                "style"
              ],
              "dataAttributes": [
                "data-activation-direction",
                "data-current",
                "data-instant",
                "data-previous",
                "data-transitioning"
              ],
              "cssVariables": [
                "--popup-height",
                "--popup-width"
              ]
            },
            "createHandle": {},
            "Handle": {}
          },
          "types": [
            "Tooltip.Arrow.Props",
            "Tooltip.Arrow.State",
            "Tooltip.Popup.Props",
            "Tooltip.Popup.State",
            "Tooltip.Portal.Props",
            "Tooltip.Portal.State",
            "Tooltip.Positioner.Props",
            "Tooltip.Positioner.State",
            "Tooltip.Provider.Props",
            "Tooltip.Provider.State",
            "Tooltip.Root.Actions",
            "Tooltip.Root.ChangeEventDetails",
            "Tooltip.Root.ChangeEventReason",
            "Tooltip.Root.Props",
            "Tooltip.Root.State",
            "Tooltip.Trigger.Props",
            "Tooltip.Trigger.State",
            "Tooltip.Viewport.Props",
            "Tooltip.Viewport.State"
          ],
          "sections": {
            "usage-guidelines": {
              "title": "Usage guidelines"
            },
            "anatomy": {
              "title": "Anatomy"
            },
            "alternatives-to-tooltips": {
              "title": "Alternatives to tooltips",
              "children": {
                "infotips": {
                  "title": "Infotips"
                },
                "description-text": {
                  "title": "Description text"
                },
                "contextual-feedback-messages": {
                  "title": "Contextual feedback messages"
                }
              }
            },
            "examples": {
              "title": "Examples",
              "children": {
                "detached-triggers": {
                  "title": "Detached triggers"
                },
                "multiple-triggers": {
                  "title": "Multiple triggers"
                },
                "controlled-mode-with-multiple-triggers": {
                  "title": "Controlled mode with multiple triggers"
                },
                "animating-the-tooltip": {
                  "title": "Animating the Tooltip",
                  "children": {
                    "position-and-size": {
                      "title": "Position and Size"
                    },
                    "content": {
                      "title": "Content"
                    }
                  }
                }
              }
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "provider": {
                  "title": "Provider"
                },
                "root": {
                  "title": "Root"
                },
                "trigger": {
                  "title": "Trigger"
                },
                "portal": {
                  "title": "Portal"
                },
                "positioner": {
                  "title": "Positioner"
                },
                "popup": {
                  "title": "Popup"
                },
                "arrow": {
                  "title": "Arrow"
                }
              }
            },
            "createhandle": {
              "title": "createHandle",
              "children": {
                "handle": {
                  "title": "Handle"
                }
              }
            }
          }
        }
      ],
      "pageMetadata": {
        "robots": {
          "index": false
        },
        "other": {
          "audience": "private"
        }
      },
      "prefix": "/react/components/"
    },
    "Utils": {
      "title": "React Utils",
      "pages": [
        {
          "slug": "csp-provider",
          "path": "./csp-provider/page.mdx",
          "title": "CSP Provider",
          "description": "Configures CSP-related behavior for inline tags rendered by Base UI components.",
          "keywords": [
            "Base UI CSP Provider",
            "Content Security Policy",
            "CSP nonce",
            "React CSP",
            "Inline script nonce",
            "Inline style nonce"
          ],
          "exports": {
            "CSPProvider": {
              "props": [
                "children",
                "disableStyleElements",
                "nonce"
              ]
            }
          },
          "types": [
            "CSPProvider.Props",
            "CSPProvider.State"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "supplying-a-nonce": {
              "title": "Supplying a nonce"
            },
            "disable-inline-style-elements": {
              "title": "Disable inline style elements"
            },
            "inline-style-attributes": {
              "title": "Inline style attributes"
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        },
        {
          "slug": "direction-provider",
          "path": "./direction-provider/page.mdx",
          "title": "Direction Provider",
          "description": "Enables RTL behavior for Base UI components.",
          "keywords": [
            "Base UI Direction Provider",
            "React RTL Context",
            "Text Direction Hook",
            "useDirection Base UI",
            "Headless RTL Components",
            "Internationalization",
            "i18n",
            "Bidirectional Text",
            "Locale Support",
            "Arabic Hebrew Support",
            "LTR RTL Switch"
          ],
          "exports": {
            "DirectionProvider": {
              "props": [
                "children",
                "direction"
              ]
            },
            "useDirection": {}
          },
          "types": [
            "DirectionProvider.Props",
            "DirectionProvider.State",
            "TextDirection"
          ],
          "sections": {
            "anatomy": {
              "title": "Anatomy"
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "directionprovider": {
                  "title": "DirectionProvider"
                },
                "usedirection": {
                  "title": "useDirection"
                }
              }
            }
          }
        },
        {
          "slug": "mergeprops",
          "path": "./merge-props/page.mdx",
          "title": "mergeProps",
          "description": "A utility to merge multiple sets of React props.",
          "exports": {
            "makeEventPreventable": {
              "parameters": [
                "event"
              ]
            },
            "mergeClassNames": {
              "parameters": [
                "ourClassName",
                "theirClassName"
              ]
            },
            "mergeProps": {
              "parameters": [
                "a",
                "b",
                "c",
                "d",
                "e"
              ]
            },
            "mergePropsN": {
              "parameters": [
                "props"
              ]
            }
          },
          "sections": {
            "how-merging-works": {
              "title": "How merging works",
              "children": {
                "preventing-base-ui-s-default-behavior": {
                  "title": "Preventing Base UI's default behavior"
                }
              }
            },
            "passing-a-function-instead-of-an-object": {
              "title": "Passing a function instead of an object"
            },
            "api-reference": {
              "title": "API reference",
              "children": {
                "mergeprops": {
                  "title": "mergeProps"
                },
                "mergepropsn": {
                  "title": "mergePropsN"
                }
              }
            }
          }
        },
        {
          "slug": "userender",
          "path": "./use-render/page.mdx",
          "title": "useRender",
          "description": "Hook for enabling a render prop in custom components.",
          "keywords": [
            "Base UI useRender",
            "React Render Prop Hook",
            "Merge Props Helper",
            "Merge Refs Hook",
            "Radix asChild Migration",
            "Component Composition",
            "Props Spreading",
            "Ref Forwarding",
            "Custom Components",
            "asChild Pattern",
            "Slot Pattern"
          ],
          "exports": {
            "ComponentRenderFn": {},
            "useRender": {
              "parameters": [
                "params"
              ]
            }
          },
          "types": [
            "HTMLProps",
            "UseRenderComponentProps",
            "UseRenderElementProps",
            "UseRenderParameters",
            "UseRenderRenderProp",
            "UseRenderReturnValue",
            "UseRenderState",
            "useRender.ComponentProps",
            "useRender.ElementProps",
            "useRender.Parameters",
            "useRender.RenderProp",
            "useRender.ReturnValue",
            "useRender.State"
          ],
          "sections": {
            "examples": {
              "title": "Examples"
            },
            "merging-props": {
              "title": "Merging props"
            },
            "merging-refs": {
              "title": "Merging refs"
            },
            "typescript": {
              "title": "TypeScript"
            },
            "migrating-from-radix-ui": {
              "title": "Migrating from Radix UI"
            },
            "render-prop-and-polymorphism": {
              "title": "Render prop and polymorphism"
            },
            "api-reference": {
              "title": "API reference"
            }
          }
        }
      ],
      "pageMetadata": {
        "robots": {
          "index": false
        },
        "other": {
          "audience": "private"
        }
      },
      "prefix": "/react/utils/"
    }
  }
} });
